import {
    BREAKS_TIME_PICKER_INTERVAL_PERIOD,
    JOB_TITLES_TIME_PICKER_INTERVAL_PERIOD
} from "../../../../../../hmodules/team-live/constants/date-picker-config.constants.js";

/**
 * Created by wajidafaneh on 29/01/2017.
 */
import {ActionTypesConstants} from "../../constants/action-types.constants.js";
import {
    TIPS_DISTRIBUTION_SOURCE_VIEW
} from "../../../../../../hmodules/tips-distribution/constants/tips-distribution-data-source.constants.js";
import {
    CENTS_PER_DOLLAR,
    INCENTIVE_PAYMENT_TYPES,
    RULE_TIERS_PAYMENT_TYPES,
} from "../../../../../../hmodules/differential-pay/constants/incentives-open-shift.constants.js";
import {
    BREAK_ACTIONS,
    BREAK_STATUSES,
    ACTION_SOURCES,
    BREAK_TYPE_CODE,
    BREAK_CATEGORIES,
    BREAK_TIME_STATUSES,
    BREAK_PENALTY_TYPES,
    BREAK_CATEGORY_CODE,
    BREAK_ATTESTATION_REASONS,
} from "../../../../../../hmodules/team-live/breaks-management/constants/actual-breaks.constants.js";

window.CTManageShiftForm = function (
    $scope,
    $filter,
    CTTimesheetService,
    TeamScheduleService,
    formData,
    userPermissions,
    userServices,
    TimesheetSettingsService,
    businessDayUtils,
    TSUsersService,
    hUser,
    ShiftTemplateUtils,
    brandServices,
    useTipsDistributionSharedFactory,
    actualClockTimeManagementService,
    jobTitlesDataService,
    useIncentiveOpenShiftPaymentFactory,
    useActualBreaksHelperFactory
 ) {
    var self = this;
    var formName = "manage-shift-form";
    var _protected = BaseForm.call(self, formName, $scope);

    var brand = formData.brand;
    var date = formData.date;
    var viewType = formData.type;
    var shift = formData.shift;
    var originalShift = angular.copy(formData.shift);
    var employee = formData.employee;
    var brandUsers = formData.brandUsers;
    var week = formData.week;
    var isSickLeaveEnabled = formData.isSickLeaveEnabled;
    var tipsDeclarationSettings = formData.tipsDeclarationSettings;
    var timeSheetAdjustmentSettings = formData.timeSheeetAdjustmentSettings || {};
    var shiftTemplates = formData.shiftTemplates;
    const _jobTitleFuncs = JobTitlesForm.call(self, jobTitlesDataService);
    let isAssigneeShiftJobTitleTimesEnforced;
    let hasResolveBreakPremiumsPermission;
    let isJobTitleSkillLevelServiceEnabled;
    let isJobTitleExtraPaySettingEnabled;
    let sickLeaveWithoutRounding;
    let brandJobTitleExtraPaySettings;
    let originalJobTitlesData;
    var originalData;
    var userActivePaytype;
    var clockTimeStatusPersonalReasonMode;
    var clocksArray = [];
    var timesheetDataDetails;
    var showPaysheetPeriodClosedForNextDay;
    var isOvernightShiftSettingsEnabled;
    var defualtWeight = 1;
    var lactationBreakEnabled = false;
    var isBreakUpdating = false;
    var allOverlappingBreaks = [];
    var hasTimesheetOfflineConflict = formData.shift && formData.shift.has_timesheet_offline_conflict;
    var canManageOwnTimeCards;
    var originalClock;
    var nextWeekOfSelectedWeekStatus;
    var weekPaysheetTypesInfo;
    var clockTimeStatusReasons = [
        {
            key: 'MANAGER_REQUEST',
            value: 'Manager Instruction'
        }
    ];
    let isBreakWaiverSettingEnabled = false;
    const isAddMissedBreakToPaidTimeOptionHidden = formData.isAddMissedBreakToPaidTimeOptionHidden;
    const actualBreaksHelperFactory = useActualBreaksHelperFactory();
    const incentiveOpenShiftPayment = useIncentiveOpenShiftPaymentFactory();
    const tipsDistributionSharedFactory = useTipsDistributionSharedFactory();

    self.BREAK_CATEGORIES = BREAK_CATEGORIES;

    self.SICK_LEAVE_INPUT_FIELD = 'SICK_LEAVE_INPUT_FIELD';

    const JOB_TITLES_FORM_FIELDS = {
        JOB_TITLE: 'job_title',
        JOB_TITLE_START_TIME: 'job_title_start_time',
        JOB_TITLE_END_TIME: 'job_title_end_time',
    }
    var BREAK_TYPES = {
        'UNSCHEDULED_PAID_MEAL': {
            label: $filter('translate')('Paid Meal'),
            code: 'UNSCHEDULED_PAID_MEAL',
            type: 'UNSCHEDULED_PAID',
            category: 'MEAL',
            icon: 'fa-cutlery'
        },'UNSCHEDULED_UNPAID_MEAL': {
            label: $filter('translate')('Unpaid Meal'),
            code: 'UNSCHEDULED_UNPAID_MEAL',
            type: 'UNSCHEDULED_UNPAID',
            category: 'MEAL',
            icon: 'fa-cutlery'
        },
        'UNSCHEDULED_PAID_ORDINARY': {
            label: $filter('translate')('Paid Rest'),
            code: 'UNSCHEDULED_PAID_ORDINARY',
            type: 'UNSCHEDULED_PAID',
            category: 'ORDINARY',
            icon: 'fa-coffee'
        },'UNSCHEDULED_UNPAID_ORDINARY': {
            label: $filter('translate')('Unpaid Rest'),
            code: 'UNSCHEDULED_UNPAID_ORDINARY',
            type: 'UNSCHEDULED_UNPAID',
            category: 'ORDINARY',
            icon: 'fa-coffee'
        }, 'PAID_LACTATION': {
            label: $filter("translate")('Paid Lactation'),
            code: 'PAID_LACTATION',
            type: 'PAID',
            category: 'LACTATION',
        },'UNPAID_LACTATION': {
            label: $filter("translate")('Unpaid Lactation'),
            code: 'UNPAID_LACTATION',
            type: 'UNPAID',
            category: 'LACTATION'
        }
    };

    self.breakTypesOptions = [];

    var TEMPLATE_NONE_OPTION = {code: 'NONE', name: '--'};

    //Triggers
    var events = {
        "break_delete": [],
        "shift_time_changed": [],
        "date_changed": [],
        "overlapping_breaks": []
    };

    var getReasonCode = function (reason) {
        return ['PAID_PERSONAL', 'UNPAID_PERSONAL'].indexOf(reason) > -1 ? 'PERSONAL' : reason;
    };

    var getClockActionWarning = function (clockAction) {
        if (self.shift.status === "APPROVED" || userActivePaytype !== "HOURLY") {
            return;
        }

        var msg = "";
        var reason = _.findWhere(self.clockOutTimeStatusReasons, {key: getReasonCode(clockAction.reason)});

        if (reason) {
            switch (clockAction.source) {
                case "SYSTEM":
                    msg = $filter("translate")("System auto resolution") + ' "' + $filter("translate")(reason.value) + '"';
                    break;
                case "EMPLOYEE":
                    msg = $filter("translate")("Employee selected") + ' "' + $filter("translate")(reason.value) + '"';
                    break;
            }
        }

        return msg;
    };

    var isCallInEnabled = function (date) {
        var callInSettings = CTTimesheetService.getCallInsSettings(date);
        return (callInSettings && callInSettings !== "NONE");
    };

    var isLactationBreaksEnabled = function (date) {
        var lactationBreaksSettings = CTTimesheetService.getLactationSettings(date);
        return (lactationBreaksSettings && lactationBreaksSettings['status'] !== "DISABLED");
    };

    var initData = function () {
        self.isTroncActionShown = tipsDistributionSharedFactory.isClockTimeTroncSummaryVisible(
            TIPS_DISTRIBUTION_SOURCE_VIEW.TIMESHEET,
            brand.tronc,
        );

        self.teamLiveCountryCode = brand.team_live_country_code;
        self.isAllFieldsDisbaled = shift && shift.status === 'DELETED';
        self.isRequestEmployeeConfirmationDisabled = true;
        self.isOverrideEmployeeConfirmationDisbaled = true;
        self.isPartiallyUnapprovedShift = shift?.actual_clock?.is_partial_paid;

        self.dateStr = new Date(date).toISOString();
        self.mode = 'ADD';
        self.shift = shift;
        defualtWeight = (self.shift && self.shift.isExtendedFromPreviousDay)? 0 : 1;

        self.breaksRulesSet = CTTimesheetService.getBreaksRulesSet(date);
        self.shiftTemplates = {};
        self.templatesCode = [];

        for (var code in shiftTemplates) {
            if (shiftTemplates[code]['status'] === 'ACTIVE') {
                self.shiftTemplates[code] = shiftTemplates[code];
                self.templatesCode.push({
                    code: code,
                    name: code,
                    weight: shiftTemplates[code].weight
                });
            }
        }

        self.templatesCode.unshift(TEMPLATE_NONE_OPTION);

        self.data = {
            breaks: {ADDITIONAL: [], ENTITLED: []}
        };

        timesheetDataDetails = CTTimesheetService.getData();
        clocksArray = timesheetDataDetails['clocks'];
        isOvernightShiftSettingsEnabled = CTTimesheetService.checkOvernightShiftsSettings(date);


        if (
            timeSheetAdjustmentSettings.employee_protest_enabled &&
            timeSheetAdjustmentSettings.is_clock_edit_reason_enabled
        ) {
            self.EditCardReasons = CTTimesheetService.getBrandEditTimeCardReasons();
        }

        self.isSickLeaveEnabled = !!isSickLeaveEnabled;

        self.viewType = viewType;
        self.selectedDate = moment(date);
        onSelectedDayChange();
        self.isGreaterThanWeekEnd = false;
        self.isLessThanWeekStart = true;
        self.tipsDeclarationEnabled = tipsDeclarationSettings && !!tipsDeclarationSettings.enable_tip_prompt;
        self.splitShiftEnabled = ['CA', 'DC'].indexOf(CTTimesheetService.getSplitShiftPenaltySettings(date)) > -1;
        self.callInEnabled = isCallInEnabled(date);
        self.effectiveBreakEngine = CTTimesheetService.getEffectiveBreakEngine(date);
        self.hasBreakRules = CTTimesheetService.checkBreakRules(date);
        lactationBreakEnabled = isLactationBreaksEnabled(date);
        prepareBreaksPaymentDetails();
        clockTimeStatusPersonalReasonMode = CTTimesheetService.getClockTimeStatusPersonalReasonMode();

        self.shiftCode = TEMPLATE_NONE_OPTION;
        self.data.weight = defualtWeight;
        self.shiftBasedScheduling = CTTimesheetService.shiftBasedScheduling;
        self.data.tips = 0;

        if (self.isTroncActionShown) {
            const brandTroncSources = brand?.tronc?.sources || [];
            const clockSources = self.shift?.tronc?.sources || [];

            let sources = [];

            for (const brandSource of brandTroncSources) {
                const sourcePots = clockSources?.filter((sourceObject) => sourceObject.code === brandSource.code);

                const totalAmount = sourcePots?.reduce((total, source) => (total + (source.amount + source.adjustment)), 0) ?? 0.0;

                const source = {
                    ...brandSource,
                    amount: Utils.roundFloat(totalAmount / 100, 2),
                };

                sources.push(source)
            }

            self.data.tronc = {
                sources: sources
            };
        }

        if (self.shift && self.shift.isExtendedFromPreviousDay && !self.isTroncActionShown) {
            self.shift.is_tips_editable = false;
        }

        sickLeaveWithoutRounding = (self.shift?.actual_clock.sick_leave_duration || 0) / 60 / 60;
        self.data["sick_leave"] = parseFloat(sickLeaveWithoutRounding.toFixed(2));
    };

    self.isWarningIconShown = function (entryStatus) {
        return (
            (entryStatus === 'CONSUMED' && self.missedUnpaidBreakMode === 'AUTO_DEDUCT') ||
            (['UNCONSUMED', 'INVOLUNTARILY_UNCONSUMED', 'LATE_CONSUMED', 'SHORT_LATE_CONSUMED', 'SHORT_CONSUMED'].indexOf(entryStatus) > -1)
        );
    };

    self.getWaiverOnFileBadgeMsg = (breakType) => {
        const orderText = breakType.order === 1 ? $filter('translate')('First') : $filter('translate')('Second');
        const categoryText = breakType.category === BREAK_CATEGORY_CODE.MEAL ? $filter('translate')('Meal') : $filter('translate')('Rest');
        return `${orderText} ${categoryText}`;
    }

    self.filterMealBreak = (breakObj) => breakObj.break_type?.category === BREAK_CATEGORY_CODE.MEAL;

    self.filterRestBreak = (breakObj) => breakObj.break_type?.category === BREAK_CATEGORY_CODE.ORDINARY;

    self.undoWarningResolve = (entry) => {
        if (self.breaksRulesSet) {
            entry.confirmedIgnoreReason = false;
            delete entry.employer_ignore_reason;

            if (isLateMealBreak(entry)) {
                entry.status = BREAK_STATUSES.LATE_CONSUMED;
            } else if (
                (
                    self.breaksRulesSet === BREAK_PENALTY_TYPES.CA &&
                    isShortMealBreak(entry) || isShortRestBreak(entry)
                ) || 
                (
                    self.breaksRulesSet === BREAK_PENALTY_TYPES.WA &&
                    isShortBreak(entry)
                )
            ) {
                entry.status = BREAK_STATUSES.SHORT_CONSUMED;
            } else if (isShortLateMealBreak(entry)) {
                entry.status = BREAK_STATUSES.SHORT_LATE_CONSUMED;
            } else {
                if (
                    [
                        BREAK_STATUSES.PENALTY_EMPLOYER_ADDED,
                        BREAK_STATUSES.PENALTY_AUTOMATICALLY_ADDED,
                        BREAK_STATUSES.EMPLOYER_CONSUMED
                    ].includes(entry.status) &&
                    entry.start_time &&
                    entry.end_time
                ) {
                    entry.status = BREAK_STATUSES.RECONSUMED;
                    self.loadingBreaksInProgress = true;
                    recalculateBreaks(entry);
                } else if (entry.status === BREAK_STATUSES.EMPLOYEE_IGNORED) {
                    entry.status = BREAK_STATUSES.INVOLUNTARILY_UNCONSUMED;
                } else {
                    if (self.missedUnpaidBreakMode === BREAK_ACTIONS.AUTO_DEDUCT) {
                        entry.status = entry.type === BREAK_TYPE_CODE.UNPAID
                            ? BREAK_STATUSES.CONSUMED
                            : BREAK_STATUSES.INVOLUNTARILY_UNCONSUMED;
                    } else {
                        entry.status = (
                            entry.type === BREAK_TYPE_CODE.PAID ||
                            entry.category === BREAK_CATEGORY_CODE.MEAL
                        ) ? BREAK_STATUSES.INVOLUNTARILY_UNCONSUMED
                          : BREAK_STATUSES.UNCONSUMED;
                    }
                }
            }
        } else {
            entry.status = BREAK_STATUSES.UNCONSUMED;
        }
        entry.is_resolved = false;
        self.validator.validation['break_start_time' + entry.id] = { errors: {} };
        self.validator.validation['break_end_time' + entry.id] = { errors: {} };
        hasBreakPenalty();
    };

    const isNormalBreak = (entry) => {
        return actualBreaksHelperFactory.isNormalBreak(entry, self.breaksRulesSet);
    };

    const isShortOrLateBreak = (entry) => {
        return actualBreaksHelperFactory.isShortOrLateBreak(entry);
    };

    self.isBreakActionsShown = (entry) => {
        return actualBreaksHelperFactory.isBreakActionsShown(entry, self.breaksRulesSet);
    };

    self.isUnResolvedWarnings = function (warning) {
        return (
            self.isUnconsumed(warning) ||
            isShortOrLateBreak(warning)
        );
    };

    self.isFixed = function (warning) {
        return  (warning.status === 'PENALTY_EMPLOYER_ADDED' || warning.status === 'EMPLOYER_ADDED' || warning.status === 'EMPLOYER_IGNORE');
    };

    self.isUnconsumed = function (warning) {
        // not resolved
        return ["INVOLUNTARILY_UNCONSUMED", "UNCONSUMED"].indexOf(warning.status) > -1;
    };

    self.isBreakDeductedBySystem = (entry) => {
        return actualBreaksHelperFactory.isBreakDeductedBySystem(entry, self.missedUnpaidBreakMode);
    };

    self.breakHasWarning = (entry) => {
        return actualBreaksHelperFactory.breakHasWarning(entry, self.breaksRulesSet);
    };

    self.isBreakWarningActionIconShown = (entry) => {
        return (
            isShortOrLateBreak(entry)
        )
    }

    self.getBreakWarningActionTooltip = (entry) => {
        return actualBreaksHelperFactory.getBreakWarningActionTooltip(entry);
    }

    self.onBreakWarningActionClick = (entry, isConfirmed) => {
        if (isShortOrLateBreak(entry)) {
            if (isConfirmed) {
                updateBreakStatus(entry, BREAK_STATUSES.PENALTY_EMPLOYER_ADDED, true);
            } else {
                updateBreakStatus(entry, BREAK_STATUSES.EMPLOYER_CONSUMED, true)
            }
        } else if (actualBreaksHelperFactory.isAutoDeductWarningShown(entry, self.missedUnpaidBreakMode)) {
            if (isConfirmed) {
                updateBreakStatus(entry, BREAK_STATUSES.EMPLOYER_CONSUMED)
            } else {
                updateBreakStatus(entry, BREAK_STATUSES.EMPLOYER_IGNORE)
            }
        } else if (actualBreaksHelperFactory.payPremiumActionConditions(entry, self.breaksRulesSet)) {
            if (isConfirmed) {
                updateBreakStatus(entry, BREAK_STATUSES.PENALTY_EMPLOYER_ADDED);
            } else {
                updateBreakStatus(entry, entry.is_waiver_on_file_applicable ? BREAK_STATUSES.IGNORED_BY_WAIVER_ON_FILE : BREAK_STATUSES.EMPLOYER_IGNORE)
            }
        } else if (actualBreaksHelperFactory.addToPaidTimeActionConditions(entry, self.breaksRulesSet)) {
            if (isConfirmed) {
                updateBreakStatus(entry,
                    (
                        entry.type === BREAK_TYPE_CODE.PAID &&
                        !isAddMissedBreakToPaidTimeOptionHidden
                    ) ?
                    BREAK_STATUSES.EMPLOYER_ADDED :
                    BREAK_STATUSES.EMPLOYER_IGNORE
                )
            } else {
                updateBreakStatus(entry, BREAK_STATUSES.EMPLOYER_IGNORE)
            }
        }
    }

    self.getBreakActionText = (entry) => {
        return actualBreaksHelperFactory.getBreakActionText(entry, self.breaksRulesSet, isAddMissedBreakToPaidTimeOptionHidden, self.missedUnpaidBreakMode);
    }

    self.isNoBreakWarningActionShown = (entry) => {
        return actualBreaksHelperFactory.isNoBreakWarningActionShown(entry, self.breaksRulesSet, hasResolveBreakPremiumsPermission, isAddMissedBreakToPaidTimeOptionHidden, self.missedUnpaidBreakMode);
    }

    self.getBreakWarningResolvedText = (entry) => {
        return actualBreaksHelperFactory.getBreakWarningResolvedText(entry, self.breaksRulesSet, self.missedUnpaidBreakMode);
    }

    var prepareBreaksPaymentDetails = function () {
        var businessDayDate = self.viewType === 'week' ? self.selectedDate.format('YYYY-MM-DD') : date;
        var breaksPaymentSetting = CTTimesheetService.getBreaksPaymentSettings(businessDayDate);
        self.paidBreakThreshold = (breaksPaymentSetting['paid_break_payment'] && breaksPaymentSetting['paid_break_payment']['threshold']) || 0;
        self.unpaidBreakThreshold = (breaksPaymentSetting['unpaid_break_payment'] && breaksPaymentSetting['unpaid_break_payment']['threshold']) || 0;
    };

    var updateCurrency = function () {
        var currency = $filter("locationCurrencySymbol")( {Location:brand.locations});
        _jobTitleFuncs.setCurrency(currency);
        self.currency = currency;
    };

    self.onDateChanged = function (handler) {
        events["date_changed"].push(handler);
    };

    self.onOverlappingBreaks = function (handler) {
        events["overlapping_breaks"].push(handler);
    };

    self.updateShift = function (_shift) {
        shift = _shift;
        init();
    };

    var trigger = function (eventName, param1, param2, param3, param4) {
        events[eventName].forEach(function (handler) {
            handler(param1, param2, param3, param4);
        });
    };

    self.hideTimeCardDetails = function () {
        return (
            [
                'NO_SHOW',
                'SICK_LEAVE',
                'NO_SHOW_MANAGER_REQUEST',
                'LEAVE_OF_ABSENCE'
            ].indexOf(self.data.category && self.data.category.category) > -1
        );
    };

    self.isMealDeductionEnabled = () => {
        return (
            self.data.employee?.is_meal_participant &&
            CTTimesheetService.data.meal_deduction_status?.[self.dateStr]?.status
        )
    };

    self.isMealPlanParticipantEnabled = () => {
        return (
            self.isMealDeductionEnabled() &&
            (
                (
                    self.data.meals ||
                    self.data.meals_value
                ) ||
                self.isMealPlanParticipantServiceEnabled
            )
        );
    };

    self.getMealDeductionValue = function() {
        return (CTTimesheetService.data.meal_deduction_status && CTTimesheetService.data.meal_deduction_status[self.dateStr]) ? parseInt(CTTimesheetService.data.meal_deduction_status[self.dateStr].payment_value) : 0;
    };

    var calculateMealDeductionValue = function () {
        var total = (self.data.meals * self.getMealDeductionValue());

        self.data.meals_value = (total) ? (total/100).toFixed(2) : 0;
    };

    self.mealsCountChanged = function() {
        calculateMealDeductionValue();
        showChangeTimeCardActionsAndWarnings();
    };

    /**
     * form.onEmployeeChange is not supported, we will map all to scope for h-change in h-select
     */

    $scope.onEmployeeChange = function () {
        self.data['position'] = null;

        self.data.employee && self.data.employee.positions && self.data.employee.positions.sort(function (pos1, pos2) {
            return pos1.name > pos2.name ? 1 : -1;
        });
        userActivePaytype = self.data.employee && TSUsersService.getUserActivePayType(self.data.employee.id, self.selectedDate);

        if (self.shiftBasedScheduling) {
            self.templatesCode = [];
            self.shiftCode = TEMPLATE_NONE_OPTION;
        }

        if (isOvernightShiftSettingsEnabled && self.data.employee) {
            showPaysheetPeriodClosedForNextDay = CTTimesheetService.isPaysheetPeriodClosedForNextDay(self.selectedDate, self.data.employee.activePaytype);
        }

        if (['UK', 'DK'].indexOf(self.teamLiveCountryCode) > -1) {
            checkDisplayEntitledOverTimeSetting();
        }

        checkOverlappingWithOtherClocks();
        updateBreaksTypesList();
        checkIfUserInLOA();

        if (self.canViewStationsSection()) {
            _jobTitleFuncs.prepareBrandUserJobTitlesListOptions(self.data.employee.id);
        }

        var lactationBreaksSettings = CTTimesheetService.getLactationSettings(date) || {};
        var isLactationExist = -1;
        if (lactationBreakEnabled) {
            if (lactationBreaksSettings['type'] === 'PAID') {
                isLactationExist = self.breakTypesOptions.findIndex(function (paidBreakTypesOption) {
                    return paidBreakTypesOption.code === 'LACTATION';
                });
            } else if (lactationBreaksSettings['type'] === 'UNPAID') {
                isLactationExist = self.breakTypesOptions.findIndex(function (unpaidBreakTypesOption) {
                    return unpaidBreakTypesOption.code === 'LACTATION';
                });
            }
        }

        self.data['breaks']['ADDITIONAL'] = self.data['breaks']['ADDITIONAL'].filter(function (eachBreak) {
            if (isLactationExist > -1) {
                return eachBreak;
            } else {
                return (
                    eachBreak &&
                    eachBreak.break_type &&
                    eachBreak.break_type.category !== 'LACTATION'
                );
            }
        });
        if (self.data.employee && isBreakWaiverSettingEnabled) {
            let requestDate = self.shift?.isExtendedFromPreviousDay ? self.selectedDate.clone().subtract(1, 'days') : self.selectedDate;
            self.breaksSectionIsLoading = true;
            PerformanceAggregatorAPI.getWaiverOnFileStatus(brand.id, self.data.employee.id, requestDate.format('YYYY-MM-DD'))
                .then(function (waiverOnFileStatus) {
                    self.waiverOnFileBreakTypes = getAppliedWaiverOnFileTypes(waiverOnFileStatus);
                    if (self.data.clock_in && self.data.clock_out && self.data.position) {
                        recalculateBreaks();
                    }
                    else {
                        self.breaksSectionIsLoading = false;
                        $scope.$digest();
                    }
                })
        }
    };

    var updateBreaksTypesList = function () {
        var employee = self.data.employee && TSUsersService.users[self.data.employee.id];
        self.breakTypesOptions = [
            BREAK_TYPES['UNSCHEDULED_PAID_MEAL'],
            BREAK_TYPES['UNSCHEDULED_UNPAID_MEAL'],
            BREAK_TYPES['UNSCHEDULED_PAID_ORDINARY'],
            BREAK_TYPES['UNSCHEDULED_UNPAID_ORDINARY']
        ];

        var hasEffectiveLactationPeriod = (employee && employee.hasEffectiveLactationPeriod(self.selectedDate)) || false;

        if (lactationBreakEnabled && hasEffectiveLactationPeriod) {
            var lactationBreaksSettings = CTTimesheetService.getLactationSettings(date) || {};

            if (lactationBreaksSettings['type'] === 'PAID') {
                self.breakTypesOptions.push(BREAK_TYPES['PAID_LACTATION']);
            }
            else if (lactationBreaksSettings['type'] === 'UNPAID') {
                self.breakTypesOptions.push(BREAK_TYPES['UNPAID_LACTATION']);
            }
        }
    };

    var getEffectivePayType = function (payTypes) {
        var effectivePayType = [];

        if (payTypes.length > 1) {
            for (var i = 0; i < payTypes.length; i++) {
                var payType = payTypes[i];
                if (
                    (moment(payType.start_date).isSameOrBefore(self.selectedDate))) {
                    effectivePayType.push(payType);
                    break;
                }
            }
        } else {
            effectivePayType = payTypes;
        }

        return effectivePayType;
    };

    var getDisabledEmployeesIds = function (employees) {
        var ids = [];
        for (var i in employees) {
            var payTypes = employees[i].user_pay_types || [];

            if (
                !payTypes.length ||
                moment(payTypes[payTypes.length - 1].start_date).isAfter(self.selectedDate) ||
                !employees[i].hasOpenPds ||
                TSUsersService.isUserInLoa(employees[i].id, self.selectedDate)
            ) {
                ids.push(employees[i].id);
            }
        }
        return ids;
    };

    var setInEffectivePayIndicator  = function () {
        for (var i in self.employees) {
            var payTypes = self.employees[i].user_pay_types || [];

            if (
                !payTypes.length ||
                moment(payTypes[payTypes.length - 1].start_date).isAfter(self.selectedDate)
            ) {
                if (!self.employees[i].indicators) {
                    self.employees[i].indicators = [];
                }
                self.employees[i].indicators.push('INEFFECTIVE_PAY');
            }
        }
    }

    var checkDisplayEntitledOverTimeSetting = function () {
        self.showEntitledOverTimeSetting = false;
        if (self.data['employee']) {
            var employeePayType = self.data['employee'].user_pay_types.length && self.data['employee'].user_pay_types[0].type;
            if ((self.salariedWeeklyOT && self.salariedWeeklyOT.is_active && employeePayType === 'SALARIED') ||
                (self.shiftyWeeklyOT && self.shiftyWeeklyOT.is_active && employeePayType === 'WEIGHTED_SHIFT')) {
                self.showEntitledOverTimeSetting = true;
            }
        } else if (_.isEmpty(self.data['employee']) && shift) {
            var shiftPayType = shift.rate && shift.rate.pay_type;
            if ((self.salariedWeeklyOT && self.salariedWeeklyOT.is_active && shiftPayType === 'SALARIED') ||
                (self.shiftyWeeklyOT && self.shiftyWeeklyOT.is_active && shiftPayType === 'WEIGHTED_SHIFT')) {
                self.showEntitledOverTimeSetting = true;
            }
        }
    };

    $scope.positionSelected = function (event) {
        userActivePaytype = TSUsersService.getUserActivePayType(self.data.employee.id, self.selectedDate);
        var position = self.data.position;
        var positionCategory = position && position.category && position.category.code;
        var positionCode = position && position.code;

        if (userActivePaytype) {
            var activeTypeManageWagePermission = 'MANAGE_' + userActivePaytype + '_EMPLOYEES_WAGES';
            var activeTypeViewWagePermission = 'VIEW_' + userActivePaytype + '_EMPLOYEES_WAGES';
            userPermissions.getBrandPolicy(brand.id)
                .then(function (policyParser) {
                    self.canManageWagesForThisPositionAndPayType = policyParser.positions(positionCategory, positionCode).hasAny([activeTypeManageWagePermission, activeTypeViewWagePermission]);
                });
                self.troncTypeSupported = tipsDistributionSharedFactory.isClockTimeTroncSummaryVisible(
                    TIPS_DISTRIBUTION_SOURCE_VIEW.TIMESHEET,
                    brand.tronc,
                    [
                        userActivePaytype,
                    ],
                );
        } else {
            self.canManageWagesForThisPositionAndPayType = false;
        }
        if (self.shiftBasedScheduling) {
            self.templatesCode = [];

            for (var i in self.shiftTemplates) {
                var template = self.shiftTemplates[i];

                for (var j in template.positions) {
                    var templatePosition = template.positions[j];

                    if (templatePosition.code === position.code) {
                        self.templatesCode.push({
                            code: template['code'],
                            name: template['code'],
                            weight: template['weight']
                        });
                    }
                }
            }

            self.templatesCode.unshift(TEMPLATE_NONE_OPTION);
            self.shiftCode = TEMPLATE_NONE_OPTION;
        }
        self.shiftPositionChanged = true;
        onShiftDetailsChange();

    };

    var updateShiftValue = function (value) {
        if (!isNaN(value)) {
            return value;
        }
        return defualtWeight;
    };

    self.templateSelected = function () {
        var code = self.shiftCode['code'];

        if (code === 'NONE') {
            self.data.weight = defualtWeight;
            return;
        }

        self.data.weight = updateShiftValue(shiftTemplates[code] && shiftTemplates[code].weight);
        var start_time = ShiftTemplateUtils.secondsToTimeObj(shiftTemplates[code].intervals[0].start_time);
        // need product confirmation, remove comment when done
        var end_time = ShiftTemplateUtils.secondsToTimeObj(shiftTemplates[code].intervals[shiftTemplates[code].intervals.length-1].end_time);
        self.data['clock_in'] = moment(date).clone().hours(start_time.hours).minutes(start_time.minutes).format("hh:mm a");
        self.data['clock_out'] = moment(date).clone().hours(end_time.hours).minutes(end_time.minutes).format("hh:mm a");
        if (self.data?.job_titles?.length) {
            _jobTitleFuncs.updateJobTitlesEndTimeOptions();
        }
    };

    self.onHideTimingTimePicker = function (elementName) {
        setTimeout(function () {
            $("." + formName).find('input[name="' + elementName + '"]').trigger('change');
        }, 500);

        var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
        let isClockOutNotWithinExtension = false
        let isClockInNotWithinExtension = false

        if (self.shift && self.shift.scheduled_shift && self.data.clock_in && elementName === 'clock_in') {
            var clockInActionReason = getReasonCode(self.shift.actual_clock.clock_in_action && self.shift.actual_clock.clock_in_action.reason);
            self.showNoneClockInReason = isClockedInOnTime();

            if (self.showNoneClockInReason) {
                self.data.clock_in_action_reason = "NONE";
            } else {
                if (self.data.clock_in_action_reason === "NONE") {
                    self.data.clock_in_action_reason = clockInActionReason;
                }
            }
        }

        if (self.shift && self.data.clock_out && elementName === 'clock_out') {
            if (self.shift.scheduled_shift) {
                let clockOutActionReason = getReasonCode(self.shift.actual_clock.clock_out_action?.reason);

                if (self.clockTimeStatusReasonTrackingMode === 'EXPLICIT' || self.callInEnabled) {
                    self.showNoneClockOutReason = isClockedOutOnTime();
                } else {
                    self.showNoneClockOutReason = (new Date(self.shift.scheduled_shift.clock_out).getTime() <= new Date(Utils.getISODate(clockTiming['endTime'])).getTime());
                }

                if (self.showNoneClockOutReason) {
                    self.data.clock_out_action_reason = "NONE";
                    self.data.sick_leave = 0;
                } else {
                    if (self.isSickLeaveEnabled && self.data.clock_out_action_reason === "SICK_LEAVE") {
                        sickLeaveWithoutRounding = calculateSickLeaveValue();
                        self.data.sick_leave = parseFloat(sickLeaveWithoutRounding.toFixed(2));
                    } else {
                        if (self.clockTimeStatusReasonTrackingMode === 'EXPLICIT') {
                            if (self.data.clock_out_action_reason === "NONE") {
                                self.data.clock_out_action_reason = clockOutActionReason;
                            }
                        } else {
                            self.data.clock_out_action_reason = clockOutActionReason === "NONE" ? "PERSONAL" : clockOutActionReason;
                        }
                    }
                }

            }

            if (self.isPartiallyUnapprovedShift) {
                isClockOutNotWithinExtension = actualClockTimeManagementService.isTimeNotWithinExtensionTime(self.data.moment_clock_in, self.data.moment_clock_out, date, true)
            }
        }
        if (isJobTitleSkillLevelServiceEnabled) {
            _jobTitleFuncs.updateIntervalStartAndEndTime({
                start_time: self.data.moment_clock_in,
                end_time: self.data.moment_clock_out
            });
            if (self.data.job_titles?.length) {
                _jobTitleFuncs.updateJobTitlesEndTimeOptions();
            }
        }
        self.shiftTimeChanged = true;
        self.isResetShiftTimesEnabled = true;
        if (!isClockOutNotWithinExtension) {
            onShiftDetailsChange();
        }
        checkOverlappingWithOtherClocks();
    };

    var checkShiftTimeIsValid = function () {
        var dateTime = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);

        return !!businessDayUtils.isWithinBusinessDay({
            start_time: dateTime.startTime,
            end_time: dateTime.endTime
        }, date, false, true);
    }

    var prepareShiftClockOutTimeOptions = function () {
        if (!self.data['moment_clock_in']) {
            self.shiftEndTimeOptions = [];
        } else {
            let from;
            let to = self.businessDayLimits.closeTime;
            if (self.isPartiallyUnapprovedShift) {
                from = self.businessDayLimits.closeTimeWithoutExtension;
            } else {
                from = self.data['moment_clock_in'];
            }

            if (self.data['moment_clock_in'].clone().add(1, 'day').isBefore(self.businessDayLimits.closeTime)) {
                to = self.data['moment_clock_in'].clone().add(1, 'day');
            }
            self.shiftEndTimeOptions = hTimePickerUtils.getIntervalOptions( {
                from: from,
                to: to,
                withInfo: true,
                minutesPeriod: 15,
                includeFrom: false,
                includeTo: true,
                closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
            });
        }
    }

    self.onShiftClockTimeChange = function (target) {
        return function (value) {
            if (target === 'clock_in') {
                self.data['moment_clock_in'] = value;
                prepareShiftClockOutTimeOptions();
            } else {
                self.data['moment_clock_out'] = value;
            }
            prepareTimeOptions();
        }
    };

    var prepareBreaksToCalculate = function (calledFromInit) {
        var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits, calledFromInit ? originalClock : null);
        var listToSend = [];

        for (var i in self.data.breaks['ENTITLED']) {
            var entry = self.data.breaks['ENTITLED'][i];
            var breakTiming = CTTimesheetService.findBreakTime(entry.start_time, entry.end_time, clockTiming);
            var breakObj = {
                break_in_action: entry['break_in_action'],
                break_out_action: entry['break_out_action'],
                category: entry['break_type'] && entry['break_type']['category'],
                duration: entry['duration'],
                id: entry['id'],
                status: entry['status'],
                waive_status: entry['waive_status'],
                type: entry['type'],
                source: entry['source'],
                employer_ignore_reason: entry['employer_ignore_reason']
            };

            if (entry['payment_mode']) {
                breakObj['payment_mode'] = entry['payment_mode'];
            }

            if (breakTiming && breakTiming['startTime'] && breakTiming['endTime']) {
                breakObj.start_time = Utils.getISODate(breakTiming.startTime);
                breakObj.end_time = Utils.getISODate(breakTiming.endTime);
            }

            listToSend.push(breakObj)
        }

        return listToSend;
    }

    var checkIfShiftGreaterThan24Hours = function () {
        var clock = {
            actual_clock: {
                clock_in: self.data['moment_clock_in'],
                clock_out: self.data['moment_clock_out']
            }
        };
        self.isGreaterThan24Hours = CTTimesheetService.checkIfClockGreaterThan24Hours(clock);
    };

    var onShiftDetailsChange = function () {
        if (self.data.clock_in && self.data.clock_out && self.data.position)  {
            self.shiftTimeIsValid = checkShiftTimeIsValid();
            if (self.isGreaterThan24Hours && self.shiftTimeIsValid) {
                checkIfShiftGreaterThan24Hours();
            }

            if (self.effectiveBreakEngine === 'STATIC' || !self.hasBreakRules) {
                formatBreaksForView([]);
            } else if ((self.shiftTimeChanged && self.shiftTimeIsValid && checkBreaksTimesIsValid()) || self.shiftPositionChanged) {
                recalculateBreaks();
            }
        }
    }

    self.isTimeCardDetailsFilled = function () {
        if (self.mode === 'ADD') {
            return self.data.employee && self.data.position && self.shiftTimeIsValid;
        }
        else {
            return self.data.position && self.shiftTimeIsValid
        }
    }

    const getDifferentialPaymentRulesMessages = (rules) => {
        const differentialPaymentLockUps = CTTimesheetService.getDifferentialPayLockUps();

        let messages = [];

        for (const rule of rules) {
            const ruleDetails = differentialPaymentLockUps.find((paymentLockup) => {
                return rule.id === paymentLockup.id;
            });

            if (ruleDetails) {
                const amount = Utils.roundFloat((ruleDetails.value || 0) / CENTS_PER_DOLLAR, 2);
                const hours = Utils.roundFloat((rule.seconds / (60 * 60)), 2);

                messages.push(
                    incentiveOpenShiftPayment
                        .prepareRulePaymentDescription(
                            ruleDetails.title,
                            hours,
                            self.currency,
                            amount,
                            self.canManageWagesForThisPositionAndPayType,
                        )
                );
            }
        }

        return messages;
    }

    const getAppliedIncentiveExtraPayRulesMessages = (shift) => {
        if (
            ! shift?.actual_clock?.incentive_payments?.length > 0
        ) {
            return [];
        }

        let messages = [];

        const duration = Utils.roundFloat(
            moment.duration(
                moment(shift.actual_clock.clock_out.replace("Z", ""))
                    .diff(moment(shift.actual_clock.clock_in.replace("Z", "")))
            ).asHours(),
            2,
        );

        const rules = CTTimesheetService.getIncentiveExtraPayRules();

        for (let rule of shift.actual_clock.incentive_payments) {

            let ruleName;
            let amount;

            if (rule.type === INCENTIVE_PAYMENT_TYPES.FIXED) {
                ruleName = $filter('translate')('manual extra amount');
                amount = Utils.roundFloat(((rule.amount / duration) / CENTS_PER_DOLLAR) || 0, 2);

            } else if (rule.type === INCENTIVE_PAYMENT_TYPES.RULE_BASED) {
                ruleName = rules?.[rule.type]?.rulesMap?.[rule.rule_id]?.name;

                let tier = rules?.[rule.type]?.rulesMap?.[rule.rule_id]?.tiers?.find((tier) => {
                    return tier.id === rule.tier_id;
                });

                const tierValue = (tier?.value || 0) / CENTS_PER_DOLLAR ;
                if (tier?.payment_type === RULE_TIERS_PAYMENT_TYPES.FIXED_RATE) {
                    amount = Utils.roundFloat(tierValue, 2);
                } else if (tier?.payment_type === RULE_TIERS_PAYMENT_TYPES.PAY_RATE_PERCENTAGE) {
                    amount = Utils.roundFloat(((shift.rate.value * tierValue) / CENTS_PER_DOLLAR) || 0, 2)
                }
            }

            messages.push(
                incentiveOpenShiftPayment
                    .prepareRulePaymentDescription(
                        ruleName,
                        duration,
                        self.currency,
                        amount,
                        self.canManageWagesForThisPositionAndPayType,
                )
            );
        }

        return messages;
    }

    var recalculateBreaks = function (breakObj, calledFromInit) {
        if (breakObj) {
            breakObj.is_loading = true;
            isBreakUpdating = true;
        }
        else {
            self.breaksSectionIsLoading = true;
        }
        setTimeout(function () {
            var payLoad = {
                clocks: []
            }
            var businessDayDate = self.viewType === 'week' ? self.selectedDate.format('YYYY-MM-DD') : date;
            if (!self.hideTimeCardDetails()) {
                var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits, calledFromInit ? originalClock : null);
                var breaks = prepareBreaksToCalculate(calledFromInit);

                if (clockTiming && clockTiming['startTime'] && clockTiming['endTime']) {
                    var actual_clock = {
                        clock_in: Utils.getISODate(clockTiming['startTime']),
                        clock_out: Utils.getISODate(clockTiming['endTime']),
                        breaks: breaks,
                        position: self.data.position
                    };
                    payLoad.clocks.push(actual_clock);
                }
            }

            GatewayTeamLiveAPI.recalculateBreaks(formData.brand.id, self.data.employee.id, businessDayDate, payLoad)
                .then(function (res) {
                    formatBreaksForView(res);
                    getBreaksOverlapping();
                    showChangeTimeCardActionsAndWarnings();
                    self.breaksSectionIsLoading = false;
                    self.shiftTimeChanged = false;
                    self.shiftPositionChanged = false;
                    self.loadingBreaksInProgress = false;
                    isBreakUpdating = false;
                    $scope.$digest();
                })
            $scope.$digest();
        }, 1500);
    }

    const parseBreakAttestationWarning = (entry, action, breakTimeStatus) => {
        return {
            label: [
                breakTimeStatus,
                entry.category === BREAK_CATEGORY_CODE.MEAL ? $filter('translate')('meal break:') : $filter('translate')('rest break:'),
                BREAK_ATTESTATION_REASONS[action.reason].label
            ].join(' '),
            color: action.reason === BREAK_ATTESTATION_REASONS.PERSONAL.code ? 'muted' : 'warning',
            tooltip: parseBreakAttestationWarningTooltip(entry, action, breakTimeStatus)
        }
    }

    const parseBreakAttestationWarningTooltip = (entry, action, breakTimeStatus) => {
        return [
            breakTimeStatus,
            BREAK_CATEGORIES[entry.category].title,
            `${$filter("translate")('break taken from')} ${entry.start_time} ${$filter("translate")('to')} ${entry.end_time}`,
            breakTimeStatus === BREAK_TIME_STATUSES.SHORT.label ? `(${entry.acual_duration / 60} out of ${entry.duration / 60} minutes)` : '',
            `${$filter("translate")('was due to')}`,
            action.reason === BREAK_ATTESTATION_REASONS.PERSONAL.code
                ? $filter("translate")('personal reasons')
                : $filter("translate")('manager request')
        ].join(' ');
    }

    const parseBreakAttestationWarnings = (entry) => {
        const breakAttestationWarnings = [];
        let breakAttestationTimeStatus;
        if (CTTimesheetService.isValidBreakActionReason(entry.break_in_action?.reason)) {
            breakAttestationTimeStatus = CTTimesheetService.parseBreakAttestationTimeStatus(entry.break_in_action?.time_status, isShortBreak(entry), true);
            if (breakAttestationTimeStatus) {
                breakAttestationWarnings.push(parseBreakAttestationWarning(entry, entry.break_in_action, breakAttestationTimeStatus))
            }
        }
        if (CTTimesheetService.isValidBreakActionReason(entry.break_out_action?.reason)) {
            breakAttestationTimeStatus = CTTimesheetService.parseBreakAttestationTimeStatus(entry.break_out_action?.time_status, isShortBreak(entry));
            if (breakAttestationTimeStatus) {
                breakAttestationWarnings.push(parseBreakAttestationWarning(entry, entry.break_out_action, breakAttestationTimeStatus))
            }
        }
        return breakAttestationWarnings
    }


    var formatBreaksForView = function (breaksList) {
        var previousEntitledBreaks = self.data.breaks['ENTITLED'].slice();
        self.data.breaks['ENTITLED'] = [];
        self.data.breaks['ADDITIONAL'] = self.data.breaks['ADDITIONAL'] || [];

        for (var i in breaksList) {
            var entry = angular.copy(breaksList[i]);
            var splittedBreak = breaksList.find(function (br) {
                return br.original_break_id === entry.id && (br.original_source === 'SPLITTED');
            })

            if (splittedBreak) {
                entry.paid = moment(entry.end_time).diff(moment(entry.start_time)) / (1000 * 60);
                entry.unpaid = moment(splittedBreak.end_time).diff(moment(splittedBreak.start_time)) / (1000 * 60);
                entry.end_time = splittedBreak.end_time;
            }

            else if (entry.original_source === 'CONVERSION') {
                entry.type = entry.type === 'PAID' ? 'UNPAID' : 'UNSCHEDULED_UNPAID';
                entry.paid = moment(entry.end_time).diff(moment(entry.start_time)) / (1000 * 60);
            }

            entry.break_type = {
                type: entry.type,
                category: entry.category,
                code: entry.type + '_' + entry.category
            }

            entry.status = entry.status === 'RECONSUMED' ? 'EMPLOYER_CONSUMED' : entry.status;
            if (entry.start_time) {
                var formattedStartTime = $filter("formatDateIgnoreTimeZone")(entry.start_time, "hh:mm A");
                entry.moment_start_time = moment(entry.start_time, 'YYYY-MM-DDTHH:mm:ss');
                entry.start_time = formattedStartTime;
            }
            if (entry.end_time) {
                var formattedEndTime = $filter("formatDateIgnoreTimeZone")(entry.end_time, "hh:mm A");
                entry.moment_end_time = moment(entry.end_time, 'YYYY-MM-DDTHH:mm:ss');
                entry.end_time = formattedEndTime;
            }
            entry.acual_duration = CTTimesheetService.getDurationInSeconds(entry.start_time, entry.end_time);
            entry.is_resolved = (
                [
                    BREAK_STATUSES.PENALTY_AUTOMATICALLY_ADDED,
                    BREAK_STATUSES.AUTOMATICALLY_IGNORED_BY_WAIVER_ON_FILE,
                    BREAK_STATUSES.IGNORED_BY_WAIVER_ON_FILE,
                    BREAK_STATUSES.PENALTY_EMPLOYER_ADDED,
                    BREAK_STATUSES.EMPLOYER_IGNORE,
                    BREAK_STATUSES.AUTOMATIC_ADD_TO_PAID_TIME,
                    BREAK_STATUSES.EMPLOYER_ADDED,
                    BREAK_STATUSES.SYSTEM_IGNORE,
                    BREAK_STATUSES.AUTOMATICALLY_IGNORED,
                    BREAK_STATUSES.EMPLOYEE_IGNORED
                ].includes(entry.status) ||
                (
                    entry.status === BREAK_STATUSES.EMPLOYER_CONSUMED && 
                    !isNormalBreak(entry) &&
                    (
                        self.breaksRulesSet !== BREAK_PENALTY_TYPES.WA ||
                        (
                            self.breaksRulesSet === BREAK_PENALTY_TYPES.WA &&
                            entry.category === BREAK_CATEGORY_CODE.MEAL &&
                            isShortBreak(entry)
                        )
                    )
                ) ||
                actualBreaksHelperFactory.isEmployeeConfirmBreakDueToPersonalReason(entry, self.breaksRulesSet)
            )

            entry.break_attestation_warnings = parseBreakAttestationWarnings(entry);

            if (self.breaksRulesSet) {
                if (isAdditionalBreak(entry)) {
                    delete entry.employer_ignore_reason;
                } else {
                    entry.confirmedIgnoreReason = self.showPersonalAgreementCheckbox(entry) && entry.employer_ignore_reason?.code === BREAK_ATTESTATION_REASONS.PERSONAL.code;
                }
            }

            updateIntervalEndTimeOptions(entry, BREAKS_TIME_PICKER_INTERVAL_PERIOD);

            if (!entry.original_break_id) {
                if (self.shift && self.shift.isViewOnly && ['CONSUMED', 'EMPLOYER_CONSUMED'].indexOf(entry.status) === -1) {
                    continue;
                }
                else if (actualBreaksHelperFactory.isEntitledBreak(entry)) {
                    if (!entry.start_time && !entry.end_time){
                        var match = previousEntitledBreaks.find(function(item) {
                            return entry.type === item.type && entry.category === item.category && entry.status === item.status;
                        });
                        if (match && (match.start_time || match.end_time)) {
                            entry = match;
                        }
                    }
                    self.data.breaks['ENTITLED'].push(entry);
                }
                else if (isAdditionalBreak(entry)) {
                    self.data.breaks['ADDITIONAL'].push(entry);
                }
            }

        }

        self.data.breaks['ENTITLED'] = sortBreaksByID(self.data.breaks['ENTITLED']);
        hasBreakPenalty();
    }

    self.showPersonalAgreementCheckbox = (entry) => {
        return actualBreaksHelperFactory.showPersonalAgreementCheckbox(entry, self.breaksRulesSet);
    }

    self.clearBreak = function (entry) {
        if (!entry.is_loading) {
            delete entry.start_time;
            delete entry.end_time;
            delete entry.paid;
            delete entry.unpaid;
            delete entry.acual_duration;
            delete entry.break_in_action;
            delete entry.isOverlappedWithOtherBreaks;
            delete entry.confirmedIgnoreReason;
            delete entry.employer_ignore_reason;
            entry.is_cleared = true;
            setTimeout(function () {
                delete entry.is_cleared;
            },400);
            self.undoWarningResolve(entry);
            if (entry.category === BREAK_CATEGORY_CODE.MEAL && self.breaksRulesSet) {
                recalculateBreaks();
            }
        }
    }

    self.getBreakTitle = function (type) {
        if (type === 'PAID' || type === 'UNSCHEDULED_PAID') {
            return $filter("translate")('Paid')
        }
        else if (type === 'UNPAID' || type === 'UNSCHEDULED_UNPAID') {
            return $filter("translate")('Unpaid')
        }
    }

    var sortBreaksByID = function (breaksArray) {
        var breaks = breaksArray.slice();

        breaks.sort(function (a, b) {
            if (a.id < b.id) {
                return -1;
            } else if (a.id > b.id) {
                return 1;
            }

            return 0;
        });

        return breaks;
    };

    self.onBreakTimeChange = function (entry, target) {
        return function (value) {
            if (target === 'start_time') {
                entry['moment_start_time'] = value;
                updateIntervalEndTimeOptions(entry, BREAKS_TIME_PICKER_INTERVAL_PERIOD);
            } else {
                entry['moment_end_time'] = value;
            }
        }
    };

    var prepareTimeOptions = function () {
        if (self.data['moment_clock_in'] && self.data['moment_clock_out']) {
            let to = self.data['moment_clock_out'];
            let from;

            if (self.isPartiallyUnapprovedShift) {
                from = self.businessDayLimits.closeTimeWithoutExtension.clone().add(15, 'minutes');
            } else {
                from = self.data['moment_clock_in'];
            }

            if (self.data['moment_clock_in'].clone().add(1, 'day').isBefore(to)) {
                to = self.data['moment_clock_in'].clone().add(1, 'day');
            }

            const buildTimePickerOptions = (minutesPeriod) => {
                return hTimePickerUtils.getIntervalOptions({
                    from: from,
                    to: to,
                    withInfo: false,
                    minutesPeriod: minutesPeriod,
                    includeFrom: true,
                    includeTo: false,
                    closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
                });
            }

            self.timeOptionsWithinShift = buildTimePickerOptions(BREAKS_TIME_PICKER_INTERVAL_PERIOD);
            self.jobTitleStartTimeOptions = buildTimePickerOptions(JOB_TITLES_TIME_PICKER_INTERVAL_PERIOD);
        } else {
            self.timeOptionsWithinShift = [];
            self.jobTitleStartTimeOptions = [];
        }
    }

    self.onTimeChangeValidate = (target, takeTheStartFromClock, takeTheEndFromClock) => {
        return (value) => {
            if (value?.isValid()) {
                const from = (takeTheStartFromClock && self.data.moment_clock_in) ? self.data.moment_clock_in.clone() : self.businessDayLimits.openTime.clone();
                const to = (takeTheEndFromClock && self.data.moment_clock_out) ? self.data.moment_clock_out.clone() : self.businessDayLimits.closeTime.clone();

                if (to.isBefore(from)) {
                    to.add(1, 'day');

                    if (to.isBefore(from)) {
                        to.add(1, 'day');
                    }
                }

                if (value.isBefore(from)) {
                    value.add(1, 'day');

                    if (value.isBefore(from)) {
                        value.add(1, 'day');
                    }
                }

                if (value.isAfter(to)) {
                    value.subtract(1, 'day');

                    if (value.isAfter(to)) {
                        value.subtract(1, 'day');
                    }
                }

                if (target === 'from' && value.isAfter(to)) {
                    value = from;
                } else if (target === 'to' && value.isBefore(from)) {
                    value = to;
                }
            }
            return value;
        }
    }

    self.prepareJobTitleEndTimeOptions = (jobTitleInterval) => {
        jobTitleInterval.moment_start_time = moment(jobTitleInterval.start_time, 'YYYY-MM-DDTHH:mm:ss');
        jobTitleInterval.moment_end_time = moment(jobTitleInterval.end_time, 'YYYY-MM-DDTHH:mm:ss');
        return updateIntervalEndTimeOptions(jobTitleInterval, JOB_TITLES_TIME_PICKER_INTERVAL_PERIOD)?.end_time_options;
    }

    var updateIntervalEndTimeOptions = function (interval, minutesPeriod) {
        if (interval.moment_start_time && self.data['moment_clock_out']) {
            let to = self.data['moment_clock_out'];
            let from = interval.moment_start_time;

            if (self.isPartiallyUnapprovedShift && self.businessDayLimits.closeTimeWithoutExtension.isAfter(interval.moment_start_time)) {
                from = self.businessDayLimits.closeTimeWithoutExtension;
            }

            if (from.clone().add(1, 'day').isBefore(to)) {
                to = self.data['moment_clock_in'].clone().add(1, 'day');
            }
            interval.end_time_options = hTimePickerUtils.getIntervalOptions({
                from: from,
                to: to,
                withInfo: true,
                minutesPeriod: minutesPeriod,
                includeFrom: false,
                includeTo: true,
                closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
            });
        } else {
            interval.end_time_options = [];
        }
        return interval;
    };

    var hasDifferentTimes = function (originalTime, updatedTime) {
        return (
            (originalTime && updatedTime && !originalTime.isSame(updatedTime)) ||
            (originalTime && !updatedTime) ||
            (!originalTime && updatedTime)
        );
    };

    var checkIfBreakChanged = function (originalBreak, updatedBreak) {
        return (
            originalBreak.type !== updatedBreak.type ||
            originalBreak.break_type.category !== updatedBreak.break_type.category ||
            originalBreak.break_type.type !== updatedBreak.break_type.type ||
            originalBreak.status !== updatedBreak.status ||
            hasDifferentTimes(originalBreak.moment_start_time, updatedBreak.moment_start_time) ||
            hasDifferentTimes(originalBreak.moment_end_time, updatedBreak.moment_end_time)
        );
    };

    var isBreaksChanged = function (breaks, comparedBreaks) {

        for (var type in breaks) {
            var breakTypeList = breaks[type];

            for (var i in breakTypeList) {
                var breakData = breakTypeList[i];
                var changedBreak = _.find(comparedBreaks[type], {id: breakData.id});

                if (!changedBreak || checkIfBreakChanged(breakData, changedBreak)) {
                    return true;
                }
            }
        }

        return false;
    };

    const checkIsBreakTimeNotWithinExtension = (validateTarget, breakEntry) => {
        if (!self.isPartiallyUnapprovedShift) {
            return false;
        }
        const targetBreakTime = validateTarget.match(/name=['"]?([^'"]*)['"]?\]/);
        const isEndTime = targetBreakTime[1] === 'break_end_time';

        return actualClockTimeManagementService.isTimeNotWithinExtensionTime(breakEntry.moment_start_time, breakEntry.moment_end_time, date, isEndTime, self.data.moment_clock_in);
    };

    self.onHideBreakTimePicker = function (validateTarget, entry) {
        if (actualBreaksHelperFactory.isEntitledBreak(entry)) {
            setTimeout(() => {
                $("." + formName)
                    .find(`[validate-index="${entry['id']}"][validate-target="${validateTarget}"] input[type="text"]`)
                    .trigger('change');
                if (self.data.clock_in && self.data.clock_out) {
                    entry.is_refused = true;
                    self.isUpdatePartialShiftBreaksRestricted = checkIsBreakTimeNotWithinExtension(validateTarget, entry);
                    if (
                        entry.start_time &&
                        entry.end_time &&
                        checkBreaksTimesIsValid() &&
                        !self.isUpdatePartialShiftBreaksRestricted
                    ) {
                        self.loadingBreaksInProgress = true;
                        entry.status = BREAK_STATUSES.RECONSUMED;
                        entry.break_in_action = entry.break_in_action || {time_status: BREAK_TIME_STATUSES.ON_TIME.code};
                        entry.break_in_action.source = ACTION_SOURCES.EMPLOYER;
                        entry.break_out_action = entry.break_out_action || {time_status: BREAK_TIME_STATUSES.ON_TIME.code};
                        entry.break_out_action.source = ACTION_SOURCES.EMPLOYER;
                        recalculateBreaks(entry);
                    }
                }
            }, 2000);
        }
        else {
            getBreaksOverlapping();
            calculateBreakPaidTime(entry);
            showChangeTimeCardActionsAndWarnings();
        }
    };

    self.onBreakTypeChanged = function (entry) {
        calculateBreakPaidTime(entry);
        showChangeTimeCardActionsAndWarnings();
    }

    var calculateBreakPaidTime = function (entry) {
       entry.paid = 0;
        if (self.unpaidBreakThreshold && entry.break_type &&
            (entry.break_type.type === 'UNSCHEDULED_UNPAID' && ['MEAL', 'ORDINARY'].indexOf(entry.break_type.category) > -1))
        {
            var startTime = moment(entry.start_time, 'h:mm a', true);
            var endTime = moment(entry.end_time, 'h:mm a', true);
            var duration = endTime.diff(startTime, 'minutes');
            var durationInSeconds = duration * 60;

            if (durationInSeconds <= self.unpaidBreakThreshold) {
                entry.paid = duration;
            }
        }
    };

    var checkBreaksTimesIsValid = function () {

        for (var i in self.data.breaks['ENTITLED']) {
            var breakObj = self.data.breaks['ENTITLED'][i];
            if (breakObj.is_refused) {
                if (breakObj.start_time && breakObj.end_time) {
                    var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
                    var breakTiming = CTTimesheetService.findBreakTime(breakObj.start_time, breakObj.end_time, clockTiming);
                    if (breakTiming.startTime.isSameOrAfter(breakTiming.endTime)) {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
        }
        return true;
    }

    var isPositionTipped = function () {
        return self.data['position'] && self.data['position'].position_settings && self.data['position'].position_settings['is_tipped']
    }

    var isTipsDistributionEnabled = function () {
        return (
            self.isTipsDistributionServiceEnabled &&
            self.isPaySheetAdmin &&
            isPositionTipped()
        );
    }

    var isTipsDeclarationEnabled = function () {
        return (
            self.tipsDeclarationEnabled &&
            self.canManageWagesForThisPositionAndPayType &&
            (
                (self.mode === 'EDIT' && self.shift && !!self.shift.tips) ||
                isPositionTipped()
            )
        );
    }

    self.showTips = function () {
        return (
            isTipsDistributionEnabled() ||
            isTipsDeclarationEnabled()
        );
    };

    self.isTipsDisabled = function () {
        return self.breaksSectionIsLoading || !self.isTipsEditable() || !self.canManageWagesForThisPositionAndPayType;
    };

    self.showTroncSources = function () {
        return (
            self.isTroncActionShown && self.troncTypeSupported
        );
    };

    self.isDeleteBtnDisabled = function () {
        return !self.isFormEditable()
    };

    self.isBreakDisabled = function (entry) {
        var isUnpaidAutoDeduct = entry.type === 'UNPAID' && self.missedUnpaidBreakMode === 'AUTO_DEDUCT';
        var isEmployerConsumed = entry.status === 'EMPLOYER_CONSUMED';
        var isFormNotEditable = !self.isFormEditable();

        if (isUnpaidAutoDeduct && isEmployerConsumed) {
            return isFormNotEditable || (isBreakUpdating && entry.start_time && entry.end_time);
        }

        return isFormNotEditable || entry.is_resolved || (isBreakUpdating && entry.start_time && entry.end_time);
    };

    self.isPartiallyPaidShift = (entry, inputToBeDisabled) => {
        return actualClockTimeManagementService.checkPartiallyPaidShift(self.isPartiallyUnapprovedShift, entry, inputToBeDisabled, originalData, date)
    };

    self.isBreakPeriodExists = (entryId) => {
        let listToCheck = originalData.breaks['ENTITLED'].concat(originalData.breaks['ADDITIONAL']);
        let breakObj = listToCheck.find(entry => entry.id === entryId);
        if (breakObj) {
            return true
        }
        return false;
    };

    self.getBreakWarningMsg = (entry) => {
        return actualBreaksHelperFactory.getBreakWarningMsg(entry, self.breaksRulesSet, self.waiverOnFileBreakTypes, self.data.breaks.ENTITLED);
    }

    const isFormEditable = (isShiftEditable) => {
        if (self.mode === 'ADD') {
            return (
                self.data.employee?.isWithinActiveLocationPeriod ||
                self.data.employee?.isWithinEmploymentPeriod ||
                self.data.employee?.hasEffectivePayType
            );
        }

        if (shift.category === "SCHEDULED_DELETED" || hasTimesheetOfflineConflict) {
            return false
        }

        return (isShiftEditable && !self.shift.isViewOnly);
    };

    self.isFormEditable = () => {
        return isFormEditable(self.shift?.is_editable);
    };

    self.isTipsEditable = function () {
        return isFormEditable(self.shift && self.shift.is_tips_editable);
    };

    self.isPositionEditable = function () {
        if (!self.isFormEditable() || self.hideTimeCardDetails() || self.breaksSectionIsLoading) {
            return false;
        }

        //if the employee is disabled then this field shouldn't be editable
        if(_.isEmpty(self.data['employee'])) {
            return false;
        }

        //if it's a schduled shift then this field shouldn't be editabel
        return !(self.shift && self.shift.scheduled_shift && self.shift.scheduled_shift.id);
    };

    self.isBreaksEditable = function () {
        if (self.mode === 'ADD' && !self.data.employee) {
            return false;
        }

        return isFormEditable(self.shift && self.shift.is_editable);
    }

    //remove a break
    self.removeBreak = function (entry) {
        self.data.breaks['ADDITIONAL'] = _.reject(self.data.breaks['ADDITIONAL'], function (breakEntry) {
            return entry.id === breakEntry.id;
        });
        getBreaksOverlapping();
        self.onFieldsChanged();
    };

    var findAvailableBreakSlots = function (shiftStart, shiftEnd, existingBreaks, breakLength) {
        var availableBreakSlots = [];

        existingBreaks.sort(function (a, b) {
            return moment(a.start_time, 'hh:mm a').isBefore(moment(b.start_time, 'hh:mm a')) ? -1 : 1;
        });

        var lastBreakEnd = shiftStart;
        for (var i = 0; i < existingBreaks.length; i++) {
            var currentBreak = existingBreaks[i];
            var currentBreakStart = moment(currentBreak.start_time, 'hh:mm a');
            var currentBreakEnd = moment(currentBreak.end_time, 'hh:mm a');

            var availableSlotStart = lastBreakEnd;
            var availableSlotEnd = currentBreakStart;

            if (availableSlotEnd.diff(availableSlotStart, 'seconds') >= breakLength) {
                availableBreakSlots.push({
                    start_time: availableSlotStart.format('hh:mm a'),
                    end_time: availableSlotEnd.format('hh:mm a')
                });
            }

            lastBreakEnd = currentBreakEnd;
        }

        var availableSlotStart = lastBreakEnd;
        var availableSlotEnd = shiftEnd;
        if (availableSlotEnd.diff(availableSlotStart, 'seconds') >= breakLength) {
            availableBreakSlots.push({
                start_time: availableSlotStart.format('hh:mm a'),
                end_time: availableSlotEnd.format('hh:mm a')
            });
        }

        return availableBreakSlots;
    };

    var calculateBreakStartAndEndTime = function (shiftStart, shiftEnd, breakLength) {
        var shiftStartMoment = moment(shiftStart, 'hh:mm a');
        var shiftEndMoment = moment(shiftEnd, 'hh:mm a');

        var existingBreaks = angular.copy(self.data.breaks['ENTITLED'].concat(self.data.breaks['ADDITIONAL']));
        var existingBreaksWithTime = existingBreaks.filter(function(breakTime) {
            return breakTime.start_time && breakTime.end_time;
        });

        var availableBreakSlots = findAvailableBreakSlots(shiftStartMoment, shiftEndMoment, existingBreaksWithTime, breakLength);

        var breakEndTime = availableBreakSlots.length === 0 ? shiftEndMoment : availableBreakSlots[availableBreakSlots.length - 1].end_time;
        var breakStartTime = moment(breakEndTime, 'hh:mm a').subtract(breakLength, 'seconds');
        return {
            start_time: moment(breakStartTime).format('hh:mm a'),
            end_time: breakEndTime
        };
    };

    const checkIfBreakLengthGreaterThanShiftLength = (shiftStartTime, shiftEndTime, breakLength) => {
        const shiftLength = CTTimesheetService.getDurationInSeconds(shiftStartTime, shiftEndTime);
        return breakLength >= shiftLength;
    };

    const updateBreakStatus = (entry, status, isRefused) => {
        entry.original_status = entry.status;
        entry.status = status;
        entry.is_resolved = true;
        if (!isRefused) {
            delete entry.start_time;
            delete entry.end_time;
            self.validator.validation['break_start_time' + entry.id] = { errors: {} };
            self.validator.validation['break_end_time' + entry.id] = { errors: {} };
        }

        if (self.breaksRulesSet) {
            entry.confirmedIgnoreReason = false;
            delete entry.employer_ignore_reason;
        }

        if (actualBreaksHelperFactory.isEntitledBreak(entry)) {
            entry.break_in_action = entry.break_in_action || {time_status: BREAK_TIME_STATUSES.ON_TIME.code};
            entry.break_in_action.source = ACTION_SOURCES.EMPLOYER;
            entry.break_out_action = entry.break_out_action || {time_status: BREAK_TIME_STATUSES.ON_TIME.code};
            entry.break_out_action.source = ACTION_SOURCES.EMPLOYER;
        }

        if (
            self.missedUnpaidBreakMode === BREAK_ACTIONS.AUTO_DEDUCT &&
            entry.status === BREAK_STATUSES.EMPLOYER_CONSUMED
        ) {
            entry.isBreakLengthGreaterThanShiftLength = checkIfBreakLengthGreaterThanShiftLength(self.data.clock_in, self.data.clock_out, entry.duration);
            if (!entry.isBreakLengthGreaterThanShiftLength) {
                var breakTime = calculateBreakStartAndEndTime(self.data.clock_in, self.data.clock_out, entry.duration);
                entry.start_time = breakTime.start_time;
                entry.end_time = breakTime.end_time;
                recalculateBreaks(entry);
            }
        }
        hasBreakPenalty();
        showChangeTimeCardActionsAndWarnings();
    };

    self.addBreakToPayTime = function (entry) {
        entry.status = 'EMPLOYER_ADDED';
        self.data.breaks.push(entry);
        showChangeTimeCardActionsAndWarnings();
    };

    //Add un-scheduled break
    self.addUnscheduledBreak = function () {
        self.data.breaks['ADDITIONAL'].push({
            status: 'EMPLOYER_CONSUMED',
            type: null,
            id: 'TEMP_' + (new Date()).getTime()
        });

        self.onFieldsChanged();
    };

    var isAdditionalBreak = function (entry) {
        return (['UNSCHEDULED_UNPAID', 'UNSCHEDULED_PAID'].indexOf(entry.type) > -1) ||
                entry.category === 'LACTATION'
    }

    const hasBreakPenalty = () => {
        self.hasRestBreakPenalty = self.hasMealBreakPenalty = self.hasUnconfirmedBreak = false;
        if (self.breaksRulesSet) {
            let numberOfConfirmedBreakPremiums = 0;
            for (const breakDetails of self.data.breaks.ENTITLED) {
                const isPenaltyAdded = [
                    BREAK_STATUSES.PENALTY_AUTOMATICALLY_ADDED,
                    BREAK_STATUSES.PENALTY_EMPLOYER_ADDED
                ].includes(breakDetails.status);
                if (isPenaltyAdded) {
                    if (breakDetails.category === BREAK_CATEGORY_CODE.MEAL) {
                        self.hasMealBreakPenalty = true;
                        numberOfConfirmedBreakPremiums++;
                    } else if (
                        breakDetails.category === BREAK_CATEGORY_CODE.ORDINARY &&
                        self.breaksRulesSet !== BREAK_PENALTY_TYPES.WA
                    ) {
                        self.hasRestBreakPenalty = true;
                    }
                }

                if (
                    self.breaksRulesSet === BREAK_PENALTY_TYPES.CA &&
                    ['EMPLOYER_CONSUMED', 'CONSUMED'].includes(breakDetails.status) &&
                    !isNormalBreak(breakDetails) &&
                    (!breakDetails.employer_ignore_reason || breakDetails.employer_ignore_reason.code !== 'PERSONAL')
                ) {
                    self.hasUnconfirmedBreak = true;
                }
            }
            if (self.hasMealBreakPenalty) {
                self.mealBreakPremiumsPenaltyFeeMsg = prepareMealBreakPremiumsPenaltyFeeMsg(numberOfConfirmedBreakPremiums);
            }
        }
    };

    self.setBreakIgnoreReason = function (breakObj) {
        breakObj.employer_ignore_reason = breakObj.employer_ignore_reason || {};
        breakObj.employer_ignore_reason.code = breakObj.confirmedIgnoreReason? 'PERSONAL': 'NONE';
        hasBreakPenalty();
    }

    var checkTimeOverlapping = function (entry1, entry2) {
        //(StartA <= EndB) and (EndA >= StartB)
        if (entry1.startTime.isBefore(entry2.endTime) && entry1.endTime.isAfter(entry2.startTime)) {
            return true;
        }
    };

    const prepareMealBreakPremiumsPenaltyFeeMsg = (numberOfConfirmedBreakPremiums) => {
        let mealBreakPremiumsPenaltyFeeMsg;
        switch (self.breaksRulesSet) {
            case BREAK_PENALTY_TYPES.CA:
                mealBreakPremiumsPenaltyFeeMsg = $filter('translate')('1 hour penalty fee for meal break');
                break;
            case BREAK_PENALTY_TYPES.WA:
                mealBreakPremiumsPenaltyFeeMsg = [
                    numberOfConfirmedBreakPremiums * 30,
                    $filter('translate')('minute penalty fee for'),
                    numbersToWords(numberOfConfirmedBreakPremiums),
                    $filter('translate')('meal'),
                    numberOfConfirmedBreakPremiums > 1 ? $filter('translate')('breaks') : $filter('translate')('break')
                ].join(' ');
                break;
        }
        return mealBreakPremiumsPenaltyFeeMsg;
    }

    var getBreaksOverlapping = function () {
        var overlappingBreaks = [];

        if (self.data['clock_in'] && self.data['clock_out']) {
            var breaksList = self.data.breaks['ENTITLED'].concat(self.data.breaks['ADDITIONAL'])
            breaksList.forEach(function (entry) {
                entry.isOverlappedWithOtherBreaks = false;
                if (['EMPLOYER_IGNORE', 'EMPLOYER_ADDED', 'PENALTY_EMPLOYER_ADDED', 'PENALTY_AUTOMATICALLY_ADDED'].indexOf(entry.status) === -1
                    && entry.start_time && entry.end_time) {
                    var breakTiming = CTTimesheetService.findTiming(entry.start_time, entry.end_time, self.businessDayLimits, originalClock);

                    breaksList.forEach(function (comparedEntry) {
                        if (['EMPLOYER_IGNORE', 'EMPLOYER_ADDED', 'PENALTY_EMPLOYER_ADDED', 'PENALTY_AUTOMATICALLY_ADDED'].indexOf(comparedEntry.status) === -1
                            && comparedEntry.start_time
                            && comparedEntry.end_time
                            && entry.id != comparedEntry.id
                        ) {
                            var comparedEntryTiming = CTTimesheetService.findTiming(comparedEntry.start_time, comparedEntry.end_time, self.businessDayLimits, originalClock);
                            if (checkTimeOverlapping(breakTiming, comparedEntryTiming)) {
                                overlappingBreaks.push(angular.copy(entry));
                                overlappingBreaks.push(angular.copy(comparedEntry));
                                entry.isOverlappedWithOtherBreaks = true;
                            }
                        }
                    });
                }
            });
        }

        allOverlappingBreaks = angular.copy(overlappingBreaks);
        trigger("overlapping_breaks", allOverlappingBreaks.length);
    };

    const calculateSickLeaveValue = () => {
        const clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
        const actualClockOutTime = new Date(Utils.getISODate(clockTiming['endTime'])).getTime();
        const scheduledClockOutTime = new Date(self.shift.scheduled_shift.clock_out).getTime();
        let sickLeaveValue = 0;
        if (scheduledClockOutTime > actualClockOutTime) {
            sickLeaveValue = (scheduledClockOutTime - actualClockOutTime) / 1000 / 60 / 60;
        }
        return sickLeaveValue;
    };

    self.clockOutActionReasonChanged = function () {
        if (self.shift && self.isSickLeaveEnabled) {
            if (self.shift.scheduled_shift && self.data.clock_out && self.data.clock_out_action_reason === "SICK_LEAVE") {
                self.showNoneClockOutReason = false;
                sickLeaveWithoutRounding = calculateSickLeaveValue();
                self.data.sick_leave = parseFloat(sickLeaveWithoutRounding.toFixed(2));
            } else {
                sickLeaveWithoutRounding = (self.shift.actual_clock.sick_leave_duration || 0) / 60 / 60;
                self.data.sick_leave = parseFloat(sickLeaveWithoutRounding.toFixed(2));
            }
        }

        showChangeTimeCardActionsAndWarnings();
    };

    self.clockInActionReasonChanged = function () {
        showChangeTimeCardActionsAndWarnings();
    };

    self.onFieldsChanged = (fieldName) => {
        if (!self.isProcessing) {
            showChangeTimeCardActionsAndWarnings();
        }
        if (fieldName === self.SICK_LEAVE_INPUT_FIELD) {
            sickLeaveWithoutRounding = self.data.sick_leave;
        }
    };

    self.toggleTimeCardChanged = function () {
        showChangeTimeCardActionsAndWarnings(false, true);
    };

    var togglePenaltyStatusChanged = function (penaltyId, oldStatus, newStatus, clockId) {
        self.originalShiftPenaltyStatus = self.originalShiftPenaltyStatus || {};
        self.originalShiftPenaltyStatus[clockId] = self.originalShiftPenaltyStatus[clockId] || {};
        self.originalShiftPenaltyStatus[clockId][penaltyId] = self.originalShiftPenaltyStatus[clockId][penaltyId] || oldStatus;
        self.penaltyStatusChanged = self.originalShiftPenaltyStatus[clockId][penaltyId] != newStatus;
        self.penaltyStatus = newStatus;
    };

    var togglePenaltyReasonChanged = function (penaltyId, oldReason, newReason, clockId, penaltyStatus) {
        self.originalShiftPenaltyReason = self.originalShiftPenaltyReason || {};
        self.originalShiftPenaltyReason[clockId] = self.originalShiftPenaltyReason[clockId] || {};
        self.originalShiftPenaltyReason[clockId][penaltyId] = self.originalShiftPenaltyReason[clockId][penaltyId] || oldReason;
        self.penaltyReasonChanged = self.originalShiftPenaltyReason[clockId][penaltyId] != newReason;
        self.penaltyStatus = penaltyStatus;
    };

    self.onPenaltyStatusUpdated = function (clockId, oldStatus, newStatus, penaltyId) {
        if (penaltyId === 'CALL_IN') {
            self.callInStatusChanged = oldStatus !== newStatus;
            self.callInStatus = newStatus;
        }
        else {
            togglePenaltyStatusChanged(penaltyId, oldStatus, newStatus, clockId);
        }

        showChangeTimeCardActionsAndWarnings();
    };

    self.onPenaltyIgnoreReasonUpdated = function (clockId, oldReason, newReason, penaltyStatus, penaltyId) {
        if (penaltyId === 'CALL_IN') {
            self.callInReasonChanged = oldReason !== newReason;
            self.callInStatus = penaltyStatus;
        }
        else {
            togglePenaltyReasonChanged(penaltyId, oldReason, newReason, clockId, penaltyStatus);
        }
        showChangeTimeCardActionsAndWarnings();
    };

    self.resetTimeCardChanged = function () {
        self.isRequestEmployeeWarningShown = false;
        self.callInStatusChanged = false;
        self.callInReasonChanged = false;
        self.isRequestEmployeeMessageSectionShown = false;
    };

    self.breaksHaveWarnings = function () {
        for (var i in self.data.breaks['ENTITLED']) {
            var breakDetails = self.data.breaks['ENTITLED'][i];
            if (['UNCONSUMED', 'INVOLUNTARILY_UNCONSUMED', 'LATE_CONSUMED', 'SHORT_LATE_CONSUMED', 'SHORT_CONSUMED'].indexOf(breakDetails.status) > -1) {
                return true;
            }
        }
    }

    /**
     * Handle showing the error on top of modal tabs on ct_edit_shift_modal.html
     * There is too many cases on this stage.
     * check if there is any changes on data from the first step
     * to show the warnings error
     */
    var showChangeTimeCardActionsAndWarnings = function (calledFromInit, statusChanged) {
        self.isRequestEmployeeWarningShown = false;
        self.isRequestEmployeeMessageSectionShown = false;

        var shift = $.extend(true, {}, self.shift);
        var originalDataCopy = $.extend(true, {}, originalData);
        var dataCopy = $.extend(true, {}, self.data);

        delete dataCopy.employee_confirmation_type;
        delete dataCopy.message;
        delete originalDataCopy.employee_confirmation_type;
        delete originalDataCopy.message;

        var originalBreaks = $.extend(true, {}, originalData.breaks);
        var newBreaks = $.extend(true, {}, self.data.breaks);
        var isBreakChanged = false;

        var originalCategory = angular.copy(originalDataCopy.category);
        var newCategory = angular.copy(dataCopy.category);
        var isCategoryChanged = false;

        delete originalDataCopy.category;
        delete dataCopy.category;

        delete originalDataCopy.breaks;
        delete dataCopy.breaks;

        delete originalDataCopy.tronc;
        delete dataCopy.tronc;

        delete originalDataCopy.weight;
        delete dataCopy.weight;

        delete originalDataCopy.job_titles;
        delete dataCopy.job_titles;

        var oldCategoryCode = originalCategory && originalCategory['category'];
        var newCategoryCode = newCategory && newCategory['category'];

        if (oldCategoryCode === newCategoryCode) {
            isCategoryChanged = (originalCategory && originalCategory['id']) !== (newCategory && newCategory['id']);
        } else {
            isCategoryChanged = true;
        }

        if (dataCopy.employee && originalDataCopy.employee) {
            delete dataCopy.employee.selected;
            delete originalDataCopy.employee.selected;

            delete dataCopy.employee.visible;
            delete originalDataCopy.employee.visible;
        }


        if (self.breaksRulesSet) {
            const changedBreaks = [];

            for(const type in originalBreaks) {
                const breakTypeList = originalBreaks[type];
                for (const breakData of breakTypeList) {
                    const changedBreak = newBreaks[type].find(b => b.id === breakData.id);
                    if (changedBreak && checkIfBreakChanged(breakData, changedBreak)) {
                        changedBreaks.push($.extend(true, {}, breakData, changedBreak));
                    }
                }
            }

            isBreakChanged = changedBreaks.some(
                breakData =>
                    breakData.status !== BREAK_STATUSES.PENALTY_EMPLOYER_ADDED &&
                    !isShortOrLateBreak(breakData)
            );

            if (!isBreakChanged) {
                isBreakChanged = newBreaks['ADDITIONAL'].some(
                    breakData => breakData.id.includes('TEMP_')
                );
            }

            if (!isBreakChanged) {
                isBreakChanged = isBreaksChanged(originalBreaks, newBreaks) || isBreaksChanged(newBreaks, originalBreaks);
            }
        } else {
            isBreakChanged = isBreaksChanged(originalBreaks, newBreaks) || isBreaksChanged(newBreaks, originalBreaks);
        }

        var updatedData = angular.copy(dataCopy);

        if (updatedData && updatedData.clock_in) {
            updatedData.clock_in = moment(updatedData.clock_in, "hh:mm a").format("hh:mm A");
        }

        if (updatedData && updatedData.clock_out) {
            updatedData.clock_out = moment(updatedData.clock_out, "hh:mm a").format("hh:mm A");
        }

        var dataChanged = (
            isBreakChanged ||
            (!calledFromInit && JSON.stringify(originalDataCopy) !== JSON.stringify(updatedData)) ||
            statusChanged ||
            (timeSheetAdjustmentSettings.is_call_in_tcaf_enabled && (
                    self.callInStatusChanged ||
                    (self.callInReasonChanged && self.callInStatus === 'IGNORED')
                )
            ) ||
            (
                self.penaltyStatusChanged ||
                (self.penaltyReasonChanged && self.penaltyStatus === 'IGNORED')
            ) && timeSheetAdjustmentSettings.is_fww_tcaf_enabled ||
            isCategoryChanged
        );

        if (
            timeSheetAdjustmentSettings.employee_protest_enabled &&
            (
                (self.mode == 'EDIT' && dataChanged) ||
                shift.employee_status === CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYEE_PROTESTED ||
                (!self.shift && timeSheetAdjustmentSettings.is_clock_edit_reason_enabled)
            )
        ) {
            self.isRequestEmployeeWarningShown = true;
            self.isRequestEmployeeMessageSectionShown = true;

            if (
                shift.employee_status === CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYEE_PROTESTED &&
                !timeSheetAdjustmentSettings.employee_protests_limit
            ) {
                if (dataChanged) {
                    self.isRequestEmployeeConfirmationDisabled = false;
                    self.isOverrideEmployeeConfirmationDisbaled = false;
                } else {
                    self.isRequestEmployeeConfirmationDisabled = true;
                    self.isOverrideEmployeeConfirmationDisbaled = false;
                    self.data.employee_confirmation_type = 'OVERRIDE_EMPLOYEE_CONFIRMATION';
                }
            }
        }

        if (!calledFromInit) {
            setTimeout(function () {
                $scope.$digest();
            }, 1);
        }
    };

    var checkEndTimeExceedBusinessDayWarning = function () {
        var showExceedBusinessDayWarning = false;

        if (self.data['clock_in'] && self.data['clock_out']) {
            var dateTime = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
            showExceedBusinessDayWarning = !!businessDayUtils.isInBusinessDayExtension({
                start_time: dateTime.startTime,
                end_time: dateTime.endTime
            }, date, false, true);
        }

        return showExceedBusinessDayWarning;
    };

    var checkOverlappingWithOtherClocks = function (calledFromInit) {
        if (self.data['clock_in'] && self.data['clock_out']) {
            var dateTime = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits, calledFromInit ? originalClock : null);

            if (self.shift && self.shift.isExtendedFromPreviousDay) {
                var shiftDate = moment(self.shift.date).clone().subtract(1, 'days');
                var actualLocalBusinessDay = businessDayUtils.getActualBusinessDay(shiftDate.format('YYYY-MM-DD'));
                var extendedBrandBusinessDay = businessDayUtils.getBusinessDayLimits(actualLocalBusinessDay, date);
                dateTime = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], extendedBrandBusinessDay, originalClock);
            }

            self.isOverlappingWithOtherClocks = CTTimesheetService.checkClocksOverlapping(
                clocksArray,
                self.shift && self.shift['actual_clock'] && self.shift['actual_clock']['id'],
                dateTime['startTime'],
                dateTime['endTime'],
                self.data['employee'] && self.data['employee']['id'],
                self.dateStr
                );
        } else {
            self.isOverlappingWithOtherClocks = false;
        }
    };

    self.isBreaksSectionShown = () => {
        return (
            self.data.employee &&
            self.data.moment_clock_in &&
            self.data.moment_clock_out &&
            self.data.position
        );
    };

    self.shiftExtendedInLockedWeek = function () {
        var showExceedBusinessDayWarning = checkEndTimeExceedBusinessDayWarning();
        if (self.data['clock_in'] && self.data['clock_out']) {
            var dateTime = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
            var startDayOfSelectedWeek = Utils.getWeekStart(self.selectedDate, brand.startDayOfWeek).format('YYYY-MM-DD');
            var startDayOfNextWeek = moment(startDayOfSelectedWeek).clone().add(7, 'days').format('YYYY-MM-DD');

            return (
                isOvernightShiftSettingsEnabled &&
                dateTime.endTime.isSameOrAfter(startDayOfNextWeek) &&
                nextWeekOfSelectedWeekStatus === 'LOCKED' &&
                showExceedBusinessDayWarning
            );
        }
        return false;
    };

    self.shiftExtendedInClosedPayPeriod = function () {
        var showExceedBusinessDayWarning = checkEndTimeExceedBusinessDayWarning();

        return (
            isOvernightShiftSettingsEnabled &&
            showPaysheetPeriodClosedForNextDay &&
            showExceedBusinessDayWarning
        );
    };

    self.validator.afterValidation(function () {
        showChangeTimeCardActionsAndWarnings();
    });

    //Custom Validation
    self.validator.validateCustom = function (field, optionsField, rule, showError) {

        var name = field.attr("name");
        var value = self.validator.getFieldValue(field);
        const fieldIndex = optionsField.attr('validate-index');
        const shiftInterval = [{
            start_time: self.data?.moment_clock_in,
            end_time: self.data?.moment_clock_out
        }];
        const jobTitleItem = self.data?.job_titles?.[fieldIndex];

        switch (rule.name) {
            case "time":
                var isValidTime = /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/.test(value);

                if (isValidTime) {
                    var timeTextField = optionsField.find('input[name=__'+name+']');

                    if (value !== timeTextField.val()) {
                        timeTextField.val(value);
                    }
                }
                return isValidTime;
            case "clock_out_max_value":
                if (self.data['clock_in'] && self.data['clock_out']) {
                    var isShiftTimeValid = checkShiftTimeIsValid();
                    return isShiftTimeValid;
                }
                break;
            //Breaks validation
            case "break_in_min_value":
                var listToCheck = self.data.breaks['ENTITLED'].concat(self.data['breaks']['ADDITIONAL']);
                var breakObj = _.find(listToCheck, function (entry) {
                    return entry.id === fieldIndex;
                });

                if (breakObj.start_time && breakObj.end_time && self.data['clock_in'] && self.data['clock_out']) {
                    var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
                    var breakTiming = CTTimesheetService.findBreakTime(breakObj.start_time, breakObj.end_time, clockTiming);
                    if (breakTiming.startTime.isBefore(clockTiming.startTime)) {
                        return false;
                    }
                }
                break;
            case "break_in_max_value":
                var listToCheck = self.data.breaks['ENTITLED'].concat(self.data['breaks']['ADDITIONAL']);
                var breakObj = _.find(listToCheck, function (entry) {
                    return entry.id === fieldIndex;
                });
                if (breakObj && breakObj.start_time && breakObj.end_time && self.data['clock_in'] && self.data['clock_out']) {
                    var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
                    var breakTiming = CTTimesheetService.findBreakTime(breakObj.start_time, breakObj.end_time, clockTiming);
                    if (breakTiming.startTime.isAfter(breakTiming.endTime) || breakTiming.startTime.isSame(breakTiming.endTime)) {
                        return false;
                    }
                }
                break;
            case "break_out_max_value":
                var listToCheck = self.data.breaks['ENTITLED'].concat(self.data['breaks']['ADDITIONAL']);
                var breakObj = _.find(listToCheck, function (entry) {
                    return entry.id === fieldIndex;
                });
                if (breakObj && breakObj.start_time && breakObj.end_time && self.data['clock_in'] && self.data['clock_out']) {
                    var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
                    var breakTiming = CTTimesheetService.findBreakTime(breakObj.start_time, breakObj.end_time, clockTiming);
                    if (breakTiming.endTime.isAfter(clockTiming.endTime)) {
                        return false;
                    }
                }
                break;
            case "max-sick-hours":
                let maxAllowedSickLeave;
                if (self.shift?.scheduled_shift) {
                    maxAllowedSickLeave = calculateSickLeaveValue();
                } else {
                    const clockInOut = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
                    const actualClockIn = clockInOut['startTime'];
                    const actualClockOut = clockInOut['endTime'];
                    let maxDuration, actualWorkedHours = 0;
                    maxDuration = moment.duration(self.businessDayLimits.closeTime.diff(self.businessDayLimits.openTime)).asHours();
                    if (actualClockIn && actualClockOut) {
                        actualWorkedHours = moment.duration(actualClockOut.diff(actualClockIn)).asHours();
                    }
                    maxAllowedSickLeave = maxDuration - actualWorkedHours;
                }

                if (maxAllowedSickLeave < 0) {
                    maxAllowedSickLeave = 0;
                }

                if (sickLeaveWithoutRounding > maxAllowedSickLeave) {
                    self.maxSickHours = parseFloat(maxAllowedSickLeave.toFixed(3));
                    return false;
                }
                break;
            case "time-within-next-payrun":
                if (self.isPartiallyUnapprovedShift && self.data['clock_in'] && self.data['clock_out']) {
                    if (name === 'clock_out') {
                       return !actualClockTimeManagementService.isTimeNotWithinExtensionTime(self.data.moment_clock_in, self.data.moment_clock_out, date, true)
                    } else {
                        const fieldIndex = optionsField.attr('validate-index');
                        let timeObj;
                        if ([JOB_TITLES_FORM_FIELDS.JOB_TITLE, JOB_TITLES_FORM_FIELDS.JOB_TITLE_START_TIME, JOB_TITLES_FORM_FIELDS.JOB_TITLE_END_TIME].includes(name)) {
                            timeObj = self.data.job_titles[fieldIndex];
                        } else {
                            timeObj = findBreakObject(fieldIndex, self.data.breaks);
                        }
                        if (timeObj?.start_time && timeObj.end_time ) {
                            return !actualClockTimeManagementService.isTimeNotWithinExtensionTime(timeObj.moment_start_time, timeObj.moment_end_time, date, ['break_end_time', 'job_title_end_time'].includes(name), self.data.moment_clock_in);
                        }
                    }
                }
                break;

            case "required-if-one-set-job-title":
                const isValueSet = _jobTitleFuncs.isJobTitleStartAndEndTimeSet(jobTitleItem, field.attr("name"));
                if (!isValueSet) {
                    return false;
                }
                break;

            case "is-job-title-within-shift-time":
                if (
                    jobTitleItem.start_time &&
                    jobTitleItem.end_time
                ) {
                    const intervals = businessDayUtils.normalizeTimeIntervals(shiftInterval, self.actualBusinessDay.open_time);
                    if (intervals) {
                        return !!ShiftTemplateUtils.isWithinShiftTime(intervals, jobTitleItem);
                    }
                }
                break;

            case "is-job-title-overlapped":
                const jobTitles = self.data.job_titles.filter((jobTitle, index) => {
                    return parseInt(index) !== parseInt(fieldIndex) && jobTitle.start_time && jobTitle.end_time;
                })
                if (
                    jobTitleItem.start_time &&
                    jobTitleItem.end_time
                ) {
                    const intervals = businessDayUtils.normalizeTimeIntervals(shiftInterval, self.actualBusinessDay.open_time);
                    return !ShiftTemplateUtils.isIntervalsOverlapped(intervals[0].start_time, jobTitleItem, jobTitles);
                }
                break;

            case 'eligible-job-title':
                if (self.data.position) {
                    return !_jobTitleFuncs.isJobTitleNotEligible(jobTitleItem.id, [self.data.position]);
                }
                break;

            case "shift-has-stations-gap":
                if (self.data.job_titles?.length) {
                    const validInterval = self.data.job_titles.every(jt => jt.start_time && jt.end_time);
                    if (validInterval) {
                        const intervals = businessDayUtils.normalizeTimeIntervals(shiftInterval, self.actualBusinessDay.open_time);
                        const normalizedJobTitles = ShiftTemplateUtils.normalizeIntervalsWithShiftTime(intervals[0].start_time, self.data.job_titles);
                        for (const interval of intervals) {
                            const intervalHasGap = ShiftTemplateUtils.hasStationsGap(interval, normalizedJobTitles);
                            if (intervalHasGap) {
                                return false;
                            }
                        }
                        return true;
                    }
                }
                break;

            case 'set-start-and-end-time':
                const jobTitlesList = jobTitlesDataService.getFormattedJobTitles();
                for (const jt of jobTitlesList) {
                    if (!jt.end_time || !jt.start_time) {
                        return false;
                    }
                }
                break;
        }

        return true;
    };

    let findBreakObject = (fieldIndex, breaks) => {
        let listToCheck = breaks['ENTITLED'].concat(breaks['ADDITIONAL']);
        return listToCheck.find(entry => entry.id === fieldIndex);
    };

    var getReasonForSave = function (reasonType) {
        var reason = reasonType === "CLOCK_IN" ? self.data.clock_in_action_reason : self.data.clock_out_action_reason;
        var reasonToSend = reason || "NONE";

        if (reason === "PERSONAL") {
            if (self.clockTimeStatusReasonTrackingMode === 'EXPLICIT') {
                var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);

                if (reasonType === "CLOCK_IN") {
                    var clockInDifference = new Date(self.shift.scheduled_shift.clock_in).getTime() - new Date(Utils.getISODate(clockTiming['startTime'])).getTime();
                    reasonToSend = clockInDifference > 0 ? "PAID_PERSONAL" : "UNPAID_PERSONAL";

                } else {
                    var clockOtDifference = new Date(self.shift.scheduled_shift.clock_out).getTime() - new Date(Utils.getISODate(clockTiming['endTime'])).getTime();
                    reasonToSend = clockOtDifference > 0 ? "UNPAID_PERSONAL" : "PAID_PERSONAL";
                }

            } else {
                reasonToSend = "UNPAID_PERSONAL";
            }
        }

        return reasonToSend;
    };

    self.getBreakTime = function (breakEntry) {
        var breakItem = {};
        var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits, originalClock);
        var breakTiming = CTTimesheetService.findBreakTime(breakEntry.start_time, breakEntry.end_time, clockTiming);

        if (breakTiming && breakTiming['startTime'] && breakTiming['endTime']) {
            breakItem['startTime'] = Utils.getISODate(breakTiming.startTime);
            breakItem['endTime'] = Utils.getISODate(breakTiming.endTime);
        }

        return breakItem;
    };

    self.updateExtendedTips = function (removeTips) {
        var defer = $q.defer();

        if (self.validator.validate(true)) {
            self.isProcessing = true;
            var businessDayDate = self.viewType === 'week' ? self.selectedDate.format('YYYY-MM-DD') : date;
            var payload = {};

            if (removeTips) {
                payload['tips'] = 0;
            } else if (self.showTips() && !self.isTipsDisabled()) {
                payload.tips = parseFloat(parseFloat((self.data['tips'] || 0) * 100).toFixed(2));
            }

            PerformanceAggregatorAPI
                .updateExtendedClockTips(brand.id, self.data['employee'].id, self.shift.actual_clock.id, businessDayDate, payload)
                .then(function (res) {
                    self.isProcessing = false;
                    var extendedClockIndex = _.findIndex(clocksArray, function (clock) {
                        return (clock.actual_clock.id === self.shift.actual_clock.id && clock.isExtendedFromPreviousDay)
                    });

                    if (extendedClockIndex > -1) {
                        if (payload['tips']) {
                            clocksArray[extendedClockIndex]['tips'] = payload['tips'];
                        } else if (payload['tronc']) {
                            clocksArray[extendedClockIndex]['tronc'] = payload['tronc'];
                        }
                    }

                    defer.resolve(clocksArray[extendedClockIndex]);
                })
                .catch(function (err) {
                    console.error(err);
                    self.isProcessing = false;
                    defer.reject(err);
                });
        } else {
            self.isProcessing = false;

            defer.reject({
                type: "FE_VALIDATION_ERROR"
            });
        }

        return defer.promise;
    };

    const isShortBreak = (entry) => {
        return actualBreaksHelperFactory.isShortBreak(entry);
    };

    const isLateMealBreak = (entry) => {
        return actualBreaksHelperFactory.isLateMealBreak(entry, self.breaksRulesSet);
    };

    const isShortRestBreak = (entry) => {
        return actualBreaksHelperFactory.isShortRestBreak(entry, self.breaksRulesSet);
    };

    const isShortMealBreak = (entry) => {
        return actualBreaksHelperFactory.isShortMealBreak(entry, self.breaksRulesSet);
    };

    const isShortLateMealBreak = (entry) => {
        return actualBreaksHelperFactory.isShortLateMealBreak(entry, self.breaksRulesSet);
    };

    self.resetShift = function () {
        updateShiftTime(originalShift);
        self.data.breaks = {'ENTITLED' : [], 'ADDITIONAL' : []};
        formatBreaksForView(originalShift.actual_clock.breaks);
        showChangeTimeCardActionsAndWarnings();
        self.isResetShiftTimesEnabled = false;
        checkIfShiftGreaterThan24Hours();
    }

    self.isEditingTemplateShiftLocked = () => {
        return (
            self.mode === ActionTypesConstants.EDIT
        ) && (
            self.shiftCode?.code !== PerformanceAggregatorAPI.ShiftTemplatesTypesConstants.NONE
        )
    }

    //Save
    self.save = function (removeTips, penaltiesData) {
        var defer = $q.defer();
        var isDeletedShift = (shift && shift.category === "SCHEDULED_DELETED");

        if (self.validator.validate(true) || isDeletedShift) {
            var isReasonRequired = self.isRequestEmployeeMessageSectionShown && timeSheetAdjustmentSettings.is_clock_edit_reason_enabled && timeSheetAdjustmentSettings.is_clock_edit_reason_mandatory;
            self.showReasonIsRequiredError = isReasonRequired && !self.data.clockEditReason;

            if (self.showReasonIsRequiredError) {
                self.isProcessing = false;

                defer.reject({
                    type: "FE_VALIDATION_ERROR"
                });

                return defer.promise;
            }

            var payload = {
                status: "APPROVED",
                actual_clock: {}
            };

            if (allOverlappingBreaks.length === 0) {
                var businessDayDate = self.viewType === 'week' ? self.selectedDate.format('YYYY-MM-DD') : date;

                if (!isDeletedShift) {

                    if (!self.hideTimeCardDetails()) {

                        var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
                        var breaks = angular.copy(self.data['breaks']['ENTITLED']).concat(angular.copy(self.data['breaks']['ADDITIONAL']));

                        breaks.forEach(function (entry) {
                            var breakTiming = CTTimesheetService.findBreakTime(entry.start_time, entry.end_time, clockTiming);

                            if (breakTiming && breakTiming['startTime'] && breakTiming['endTime']) {
                                entry.start_time = Utils.getISODate(breakTiming.startTime);
                                entry.end_time = Utils.getISODate(breakTiming.endTime);
                            }

                            if (entry.id.indexOf("TEMP") > -1) {
                                delete (entry.id);
                            }
                            entry['category'] = entry['break_type'] && entry['break_type']['category'];
                            entry['type'] = entry['break_type'] && entry['break_type']['type'];
                            delete entry['break_type'];
                            delete entry.original_source;
                            delete entry.confirmedIgnoreReason;

                            if (entry.employer_ignore_reason && entry.employer_ignore_reason.code === 'NONE') {
                                delete entry.employer_ignore_reason;
                            }
                        });

                        if (clockTiming && clockTiming['startTime'] && clockTiming['endTime']) {
                            var actual_clock = {
                                clock_in: Utils.getISODate(clockTiming['startTime']),
                                clock_out: Utils.getISODate(clockTiming['endTime']),
                                breaks: breaks
                            };
                        }

                        payload['actual_clock'] = actual_clock;


                        if (self.shiftBasedScheduling && self.shiftCode?.['code'] !== PerformanceAggregatorAPI.ShiftTemplatesTypesConstants.NONE) {
                            payload.actual_clock.code = self.shiftCode['code'];
                        }

                        payload.actual_clock.weight = updateShiftValue(self.data.weight);

                        if (self.data.job_titles?.length) {
                            payload.actual_clock.job_titles = self.data.job_titles.map(jobTitle => {
                                const stationsTiming = CTTimesheetService.findBreakTime(jobTitle.start_time, jobTitle.end_time, clockTiming);

                                const jobTitleData = {
                                    job_title_lookup_id: jobTitle.jobTitle.id,
                                    start_time: Utils.getISODate(stationsTiming.startTime),
                                    end_time: Utils.getISODate(stationsTiming.endTime)
                                }
                                if (jobTitle.id && originalJobTitlesData.find(original => original.job_title_lookup_id === jobTitle.jobTitle.id)) {
                                    jobTitleData.id = jobTitle.id
                                }
                                if (jobTitle.rate) {
                                    jobTitleData.rate = jobTitle.rate
                                }
                                return jobTitleData
                            });
                        }

                        if (
                            (self.salariedWeeklyOT && self.salariedWeeklyOT.is_active && userActivePaytype === 'SALARIED') ||
                            (self.shiftyWeeklyOT && self.shiftyWeeklyOT.is_active && userActivePaytype === 'WEIGHTED_SHIFT')
                        ) {
                            payload.actual_clock.overtime = {
                                is_weekly_entitled: self.data.entitledOvertime
                            };
                        }

                        if (
                            self.clockTimeStatusReasonTrackingMode === 'EXPLICIT' ||
                            self.isSickLeaveEnabled ||
                            self.callInEnabled
                        ) {
                            if (self.isSickLeaveEnabled) {
                                payload.actual_clock.sick_leave_duration = Math.round(sickLeaveWithoutRounding * 60 * 60);
                            }
                            if (userActivePaytype === "HOURLY") {
                                payload.actual_clock.clock_in_action = {
                                    reason: getReasonForSave('CLOCK_IN')
                                };

                                payload.actual_clock.clock_out_action = {
                                    reason: getReasonForSave('CLOCK_OUT')
                                }
                            }
                        }

                        if (removeTips) {
                            payload.actual_clock.tips = 0;

                        } else if (self.showTips() && !self.isTipsDisabled()) {
                            payload.actual_clock.tips = parseFloat(parseFloat((self.data['tips'] || 0) * 100).toFixed(2));
                        }

                        if (self.isMealPlanParticipantEnabled()) {
                            payload.actual_clock.meals = self.data.meals;
                        }

                        if (self.showSplitShiftStatus()) {
                            payload.actual_clock.split_shift_penalty = {
                                status: self.data.split_shift_status ? "INCLUDED" : "EXCLUDED"
                            }
                        }
                    }

                }

                if (self.isRequestEmployeeMessageSectionShown) {
                    payload.message = self.data.message;

                    if (self.data.employee_confirmation_type) {
                        payload.employee_confirmation_type = self.data.employee_confirmation_type;
                    }

                    if (self.data.clockEditReason) {
                        payload.clock_edit_reason = {
                            id: self.data.clockEditReason && self.data.clockEditReason.id
                        };
                    }
                }

                if (penaltiesData) {
                    if (penaltiesData.penalties) {
                        payload.actual_clock.penalties = penaltiesData.penalties;
                    }

                    if (penaltiesData.right_to_rest) {
                        payload.actual_clock.right_to_rest = penaltiesData.right_to_rest;
                    }
                    if (self.callInEnabled) {
                        payload.actual_clock.call_in = penaltiesData.call_in;
                    }

                }

                self.isProcessing = true;

                if (self.mode === 'ADD') {

                    payload.status = "PENDING_APPROVAL";

                    if (!isDeletedShift) {
                        payload.actual_clock.position = self.data.position;
                    }

                    PerformanceAggregatorAPI.addClockEntry(brand.id, self.data['employee'].id, businessDayDate, viewType, payload)
                        .then(function (res) {
                            self.isProcessing = false;
                            defer.resolve(res);
                        }, function (err) {
                            self.isProcessing = false;
                            defer.reject(err);
                            console.error("err", err);
                        });
                } else {

                    if (!isDeletedShift) {
                        if (self.shift.actual_clock.shift_id) {
                            payload.shift_id = self.shift.actual_clock.shift_id.toString();
                        }

                        payload.actual_clock.position = self.data.position;

                        if (self.data.category) {
                            payload.actual_clock.category = (
                                self.data.category === 'NO'
                            ) ? 'ORDINARY' : self.data.category.category;

                            if (self.data.category.id || self.data.category.category === 'NO_SHOW') {
                                payload.actual_clock.error_reason = {
                                    id: self.data.category.id
                                };
                            }
                        }
                    }

                    PerformanceAggregatorAPI.updateClockEntry(brand.id, employee.id, self.shift.actual_clock.id, businessDayDate, viewType, payload)
                        .then(function (res) {
                            self.isProcessing = false;
                            defer.resolve(res);
                        }, function (err) {
                            self.isProcessing = false;
                            defer.reject(err);
                            console.error("err", err);
                        });
                }
            } else {
                self.isProcessing = false;

                defer.reject({
                    type: "FE_VALIDATION_ERROR"
                });
            }
        } else {
            self.isProcessing = false;

            defer.reject({
                type: "FE_VALIDATION_ERROR"
            });
        }

        return defer.promise;
    };

    self.addDay = function () {
        // if less than week to date
        if (week.to.startOf('day').diff(self.selectedDate, 'day') > 0 && self.selectedDate.isBefore(moment(), 'day')) {
            self.selectedDate.add(1, 'd');

            if (self.data['moment_clock_in']) {
                self.data['moment_clock_in'].add(1,'d');
            }
            if (self.data['moment_clock_out']) {
                self.data['moment_clock_out'].add(1,'d');
            }

            onSelectedDayChange();
            self.isGreaterThanWeekEnd = false; // do not disable button
            self.isLessThanWeekStart = false;
            checkEmploymentPeriod();

            getEmployerPrivilegedActiveEmployees();
        }

        self.callInEnabled = isCallInEnabled(date);
        self.effectiveBreakEngine = CTTimesheetService.getEffectiveBreakEngine(date);
        self.hasBreakRules = CTTimesheetService.checkBreakRules(date);
        lactationBreakEnabled = isLactationBreaksEnabled(date);
        self.breaksRulesSet = CTTimesheetService.getBreaksRulesSet(date);
        prepareBreaksPaymentDetails();
        checkClockTimeStatusReasonTrackingMode();
        self.splitShiftEnabled = ['CA', 'DC'].indexOf(CTTimesheetService.getSplitShiftPenaltySettings(self.selectedDate.format('YYYY-MM-DD'))) > -1;

        if (week.to.startOf('day').diff(self.selectedDate, 'day') <= 0 || self.selectedDate.isSame(moment(), 'day')) {
            self.isGreaterThanWeekEnd = true; // disable button
        }

        checkOverlappingWithOtherClocks();
        self.shiftTimeChanged = true;
        onShiftDetailsChange();
        checkIfUserInLOA();
    };

    var checkDateWithinEmploymentPeriod = function (brandUser, date, checkNextDay) {
        var isWithinEmploymentPeriod = (brandUser && brandUser.isDateWithinEmploymentPeriod(date)) || false;

        if (brandUser && checkNextDay) {
            var selectedDate = moment(date);
            var nextDate = selectedDate.clone().add(1, 'days');

            isWithinEmploymentPeriod = isWithinEmploymentPeriod && brandUser.isDateWithinEmploymentPeriod(nextDate);
        }

        return isWithinEmploymentPeriod;
    };

    var checkDateWithinActiveLocationPeriod = function (brandUser, date, checkNextDay) {
        var isWithinActiveLocationPeriod = (brandUser && brandUser.isDateWithinActiveLocationPeriod(date)) || false;

        if (brandUser && checkNextDay) {
            var selectedDate = moment(date);
            var nextDate = selectedDate.clone().add(1, 'days');

            isWithinActiveLocationPeriod = isWithinActiveLocationPeriod && brandUser.isDateWithinActiveLocationPeriod(nextDate);
        }

        return isWithinActiveLocationPeriod;
    };

    var canSelectEmployee = function () {
        var canSelectEmployee = self.data.employee.isWithinEmploymentPeriod &&
            self.data.employee.isWithinActiveLocationPeriod &&
            self.data.employee.hasEffectivePayType &&
            self.data.employee.hasOpenPds
        trigger('date_changed', canSelectEmployee);
    };

    var checkEmploymentPeriod = function () {
        if (self.data.employee) {
            var brandUser = _.find(brandUsers, function(entry) {
                return self.data.employee.id === entry.id;
            });

            self.data.employee.isWithinEmploymentPeriod = checkDateWithinEmploymentPeriod(brandUser, self.selectedDate, false);
            self.data.employee.isWithinActiveLocationPeriod = checkDateWithinActiveLocationPeriod(brandUser, self.selectedDate, false);
            self.data.employee.activePaytype = brandUser && TSUsersService.getUserActivePayType(brandUser.id, self.selectedDate);
            self.data.employee.hasEffectivePayType = !!(self.data.employee.activePaytype) || false;
            self.data.employee.hasOpenPds = userHasOpenPds(self.data.employee.activePaytype);
            canSelectEmployee();
            if (isOvernightShiftSettingsEnabled) {
                showPaysheetPeriodClosedForNextDay = CTTimesheetService.isPaysheetPeriodClosedForNextDay(self.selectedDate, self.data.employee.activePaytype);
            }
        }
    };

    self.isNextDayWithinEmploymentPeriod = function () {
        var isNextDayWithinEmploymentPeriod = true;
        var isNextDayWithinLocationPeriod = true;

        if (self.data.employee && isOvernightShiftSettingsEnabled && self.showExtendedShiftIcon()) {
            var brandUser = _.find(brandUsers, function(entry) {
                return self.data.employee.id === entry.id;
            });

            isNextDayWithinEmploymentPeriod = checkDateWithinEmploymentPeriod(brandUser, self.selectedDate, true);
            isNextDayWithinLocationPeriod = checkDateWithinActiveLocationPeriod(brandUser, self.selectedDate, true);
        }

        return isNextDayWithinEmploymentPeriod && isNextDayWithinLocationPeriod;
    };

    self.subtractDay = function () {
        // if greater than week from date
        if (self.selectedDate.diff(week.from.startOf('day'), 'day') > 0) {
            self.selectedDate.subtract(1, 'd');

            if (self.data['moment_clock_in']) {
                self.data['moment_clock_in'].subtract(1,'d');
            }

            if (self.data['moment_clock_out']) {
                self.data['moment_clock_out'].subtract(1,'d');
            }

            onSelectedDayChange();
            self.isLessThanWeekStart = false; // do not disable button
            self.isGreaterThanWeekEnd = false;
            checkEmploymentPeriod();

            getEmployerPrivilegedActiveEmployees();
        }

        self.callInEnabled = isCallInEnabled(date);
        self.effectiveBreakEngine = CTTimesheetService.getEffectiveBreakEngine(date);
        self.hasBreakRules = CTTimesheetService.checkBreakRules(date);
        self.breaksRulesSet = CTTimesheetService.getBreaksRulesSet(date);
        checkClockTimeStatusReasonTrackingMode();
        self.splitShiftEnabled = ['CA', 'DC'].indexOf(CTTimesheetService.getSplitShiftPenaltySettings(self.selectedDate.format('YYYY-MM-DD'))) > -1;

        if (self.selectedDate.diff(week.from.startOf('day'), 'day') <= 0) {
            self.isLessThanWeekStart = true; // disable button
        }

        checkOverlappingWithOtherClocks();
        self.shiftTimeChanged = true;
        onShiftDetailsChange();
        checkIfUserInLOA();
    };

    var checkIfUserInLOA = function () {
        if (self.data.employee) {
            self.isSelectedUserInLOA = TSUsersService.isUserInLoa(self.data.employee.id, self.selectedDate);
        }
    }

    var getEmployerPrivilegedActiveEmployees = function (calledFromInit) {
        var defer = $q.defer();
        var date = self.selectedDate.format('YYYY-MM-DD');

        TeamAPI.getEmployerPrivilegedActiveEmployees(brand.id, "TIMESHEET", date)
            .then(function (res) {

                if (employee && res.users) {
                    var selectedEmployeeNotReturned = _.findIndex(res.users, {id: employee.id}) === -1;

                    if (selectedEmployeeNotReturned || employee.mode === 'GUEST') {
                        if (!employee.positions || !employee.positions.length) {
                            employee.positions = [shift.actual_clock.position];
                        }

                        res.users.push(employee);
                    }
                }

                self.employees = _.map(res.users, function (employee) {
                    employee.name = employee.first_name + ' ' + employee.last_name;
                    var brandUser = _.find(brandUsers, function(entry) {
                        return employee.id === entry.id;
                    });

                    if (employee && employee.mode === 'GUEST' && !brandUser) {
                        brandUser = TSUsersService.users[employee.id];
                    }

                    employee.user_pay_types = (brandUser && getEffectivePayType(brandUser.user_pay_types)) || [];
                    employee.isWithinEmploymentPeriod = checkDateWithinEmploymentPeriod(brandUser, self.selectedDate, false);
                    employee.isWithinActiveLocationPeriod = checkDateWithinActiveLocationPeriod(brandUser, self.selectedDate, false);
                    employee.profileImageURL = brandUser && TSUsersService.users[brandUser.id].profileImageURL;
                    employee.activePaytype = brandUser && TSUsersService.getUserActivePayType(brandUser.id, self.selectedDate);
                    employee.hasEffectivePayType = !!(employee.activePaytype) || false;
                    employee.hasOpenPds = userHasOpenPds(employee.activePaytype);


                    if (TSUsersService.isUserInLoa(employee.id, self.selectedDate)) {
                        if (!employee.indicators) {
                            employee.indicators = [];
                        }
                        employee.indicators.push('LOA');
                    }
                    if (!employee.hasOpenPds) {
                        if (!employee.indicators) {
                            employee.indicators = [];
                        }
                        employee.indicators.push('CLOSED_PDS');
                    }

                    return employee;
                });

                self.employees = self.employees.filter(function (employee) {
                    return (employee.isWithinActiveLocationPeriod || employee.isWithinEmploymentPeriod) && employee.positions && employee.positions.length;
                });

                self.disabledEmployeesIds = getDisabledEmployeesIds(self.employees);
                setInEffectivePayIndicator();

                // assign employee
                if (employee) {
                    self.data['employee'] = _.find(self.employees, function (entry) {
                        return entry.id === employee.id;
                    });
                    if (self.isMealDeductionEnabled()) {

                        self.data.meals = (self.shift && self.shift.actual_clock.meals) ? angular.copy(self.shift.actual_clock.meals) : 0;
                        self.data.meals_value = (self.shift && self.shift.total_meals_deduction) ? (self.shift.total_meals_deduction/100).toFixed(2) : 0;
                        calculateMealDeductionValue();
                    }

                    //assign position
                    if (self.data['employee'] && shift && shift.actual_clock && shift.actual_clock.position) {
                        self.data.position = _.find(self.data.employee.positions, function (entry) {
                            return entry.code === shift.actual_clock.position.code;
                        });

                        if (!self.data.position) {
                            self.data.position = shift.actual_clock.position;
                        }

                    } else if (_.isEmpty(self.data['employee']) && shift) {
                        self.data.position = angular.copy(shift.actual_clock.position);
                    }

                    if (shift && shift.actual_clock && shift.actual_clock.overtime) {
                        checkDisplayEntitledOverTimeSetting();
                        self.data.entitledOvertime = angular.copy(shift.actual_clock.overtime.is_weekly_entitled);
                    }
                    if (self.data.employee) {
                        canSelectEmployee();
                    }
                }

                if (!calledFromInit) {
                    originalData = $.extend(true, {}, self.data); // originalData don't affect b  aya change bseer 3 self.data
                    showChangeTimeCardActionsAndWarnings(true);
                    updateEmployeesByManageOwnTimecardPermission();
                }
                else {
                    if (isOvernightShiftSettingsEnabled && self.data.employee) {
                        showPaysheetPeriodClosedForNextDay = CTTimesheetService.isPaysheetPeriodClosedForNextDay(self.selectedDate, self.data.employee.activePaytype);
                    }
                }

                if (['UK', 'DK'].indexOf(self.teamLiveCountryCode) > -1) {
                    checkDisplayEntitledOverTimeSetting();
                }

                self.loading = false;
                $scope.$digest();
                defer.resolve();
            }, function (error) {
                console.error(error);
                self.loading = false;
                defer.resolve();
                $scope.$digest();
            });

        return defer.promise;
    };

    var userHasOpenPds = function (userActivePaytype) {

        if (!userActivePaytype || _.isEmpty(weekPaysheetTypesInfo) || !weekPaysheetTypesInfo[userActivePaytype]) {
            return true;
        }

        if (userActivePaytype === 'SALARIED' && weekPaysheetTypesInfo['SALARIED'] && weekPaysheetTypesInfo['SALARIED'].allow_paysheet_early_closure) {
            return true;
        }

        var paysheetStatusInfo = weekPaysheetTypesInfo[userActivePaytype].paysheet_statuses;
        var pdsOpenInSelectedDay = true;

        for (var i in paysheetStatusInfo) {
            var paysheetStatusInfoDate = $filter("formatDateIgnoreTimeZone")(paysheetStatusInfo[i]['date'], "YYYY-MM-DD");
            if (moment(paysheetStatusInfoDate).isSame(self.selectedDate, "days")) {
                pdsOpenInSelectedDay = paysheetStatusInfo[i]['status'] === 'OPEN';
                break;
            }
        }
        return pdsOpenInSelectedDay;
    };

    var checkClockTimeStatusReasonTrackingMode = function () {
        self.clockTimeStatusReasonTrackingMode = "IMPLICIT";

        for (var i in CTTimesheetService.clockTimeStatusReasonTrackingSettings) {
            var dateSetting = CTTimesheetService.clockTimeStatusReasonTrackingSettings[i];

            if (moment(date).valueOf() >= moment(dateSetting.start_date, 'YYYY-MM-DD').valueOf()) {
                self.clockTimeStatusReasonTrackingMode = dateSetting.clock_time_status_reason_tracking_mode;
                break;
            }
        }
    };

    self.isClockEarlyReasonDisabled = function () {
        return (
            self.breaksSectionIsLoading ||
            !self.isFormEditable() ||
            self.mode === 'ADD' ||
            (self.data.clock_out_action_reason === 'NONE') ||
            self.isClockedOutAfterScheduledTime() ||
            (self.mode === 'EDIT' && self.data.clock_out_action_reason === "NONE")
        );
    };

    var isClockedInOnTime = function () {
        var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
        return self.shift.scheduled_shift && clockTiming['startTime'] && (new Date(self.shift.scheduled_shift.clock_in).getTime() === new Date(Utils.getISODate(clockTiming['startTime'])).getTime());
    };

    var isClockedOutOnTime = function () {
        var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
        return self.shift.scheduled_shift && clockTiming['endTime'] && (new Date(self.shift.scheduled_shift.clock_out).getTime() === new Date(Utils.getISODate(clockTiming['endTime'])).getTime());
    };

    var isClockedInAfterOrSameScheduledTime = function () {
        if (!self.data['clock_in'] || !self.data['clock_out'] || !self.shift || !self.shift.scheduled_shift) {
            return false;
        }
        var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
        return (new Date(Utils.getISODate(clockTiming['startTime'])).getTime() <= new Date(self.shift.scheduled_shift.clock_in).getTime());
    };

    var isClockedOutBeforeOrSameScheduledTime = function () {
        if (!self.data['clock_in'] || !self.data['clock_out'] || !self.shift || !self.shift.scheduled_shift) {
            return false;
        }

        var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
        return (new Date(Utils.getISODate(clockTiming['endTime'])).getTime() >= new Date(self.shift.scheduled_shift.clock_out).getTime());
    };

    self.isClockedOutAfterScheduledTime = function () {
        if (!self.data['clock_in'] || !self.data['clock_out'] || !self.shift || !self.shift.scheduled_shift) {
            return false;
        }

        var clockTiming = CTTimesheetService.findTiming(self.data['clock_in'], self.data['clock_out'], self.businessDayLimits);
        return (new Date(Utils.getISODate(clockTiming['endTime'])).getTime() > new Date(self.shift.scheduled_shift.clock_out).getTime());
    };

    self.isClockOutActionReasonDisabled = function () {
        var isTimeValid = false;
        if (self.clockTimeStatusReasonTrackingMode === 'EXPLICIT') {
            isTimeValid = isClockedOutOnTime();
        }
        else if (self.callInEnabled) {
            isTimeValid = isClockedOutBeforeOrSameScheduledTime();
        }
        return (
            self.breaksSectionIsLoading ||
            !self.isFormEditable() ||
            (self.mode === 'EDIT' && self.data.clock_out_action_reason === "NONE") ||
            isTimeValid
        );
    };

    self.isClockInActionReasonDisabled = function () {
        var isTimeValid = false;
        if (self.clockTimeStatusReasonTrackingMode === 'EXPLICIT') {
            isTimeValid = isClockedInOnTime();
        }
        else if (self.callInEnabled) {
            isTimeValid = isClockedInAfterOrSameScheduledTime();
        }
        return (
            self.breaksSectionIsLoading ||
            self.isPartiallyUnapprovedShift ||
            !self.isFormEditable() ||
            (self.mode === 'EDIT' && self.data.clock_in_action_reason === "NONE") ||
            isTimeValid
        );
    };

    self.showClockTimeReasons = function () {
        return (
            (self.clockTimeStatusReasonTrackingMode === 'EXPLICIT' || self.callInEnabled) &&
            self.mode === 'EDIT' &&
            userActivePaytype === "HOURLY" &&
            self.shift.scheduled_shift
        );
    };

    self.showSplitShiftStatus = function () {
        return (
            self.splitShiftEnabled &&
            userActivePaytype === "HOURLY" &&
            self.isUSBrand
        );
    };

    self.showExtendedShiftIcon = function () {
        var showExceedBusinessDayWarning = checkEndTimeExceedBusinessDayWarning();
        var isExtendedFromPreviousDay = self.shift && self.shift.isExtendedFromPreviousDay;

        return (
            !isExtendedFromPreviousDay &&
            showExceedBusinessDayWarning
        );
    };

    self.showClockOutEarlyReasons = function () {
       return (
           self.isUSBrand &&
           self.clockTimeStatusReasonTrackingMode !== 'EXPLICIT' &&
           !self.callInEnabled &&
           self.isSickLeaveEnabled
       );
    };

    var onSelectedDayChange = function () {
        date = self.selectedDate.format('YYYY-MM-DD');
        const selectedDate = self.selectedDate.format('MMM DD, YYYY');
        self.actualBusinessDay = businessDayUtils.getActualBusinessDay(selectedDate);
        self.businessDayLimits = businessDayUtils.getBusinessDayLimits(self.actualBusinessDay, selectedDate);
        var to = self.businessDayLimits.closeTimeWithoutExtension;
        if (self.businessDayLimits.openTime.clone().add(1, 'day').isBefore(self.businessDayLimits.closeTimeWithoutExtension)) {
            to = self.businessDayLimits.openTime.clone().add(1, 'day');
        }
        self.shiftStartTimeOptions = hTimePickerUtils.getIntervalOptions( {
            from: self.businessDayLimits.openTime,
            to: to,
            withInfo: false,
            minutesPeriod: 15,
            includeFrom: true,
            includeTo: false,
            closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
        });

        self.data.breaks['ENTITLED'] = [];
        prepareShiftClockOutTimeOptions();
        prepareTimeOptions();
        if (brandJobTitleExtraPaySettings?.length) {
            isJobTitleExtraPaySettingEnabled = checkJobTitleExtraPaySettingVersion(brandJobTitleExtraPaySettings);
            if (isJobTitleExtraPaySettingEnabled) {
                _jobTitleFuncs.updateIntervalStartAndEndTime({
                    start_time: self.data.moment_clock_in,
                    end_time: self.data.moment_clock_out
                });
                _jobTitleFuncs.prepareBrandUserJobTitlesListOptions(self.data.employee);
            }
        }
        self.dateStr = new Date(date).toISOString();
    };

    var updateEmployeesByManageOwnTimecardPermission = function () {
        var currentUser = hUser.getUser();
        if (!canManageOwnTimeCards) {
            self.employees = $.grep(self.employees, function (employee) {
                return employee.id !== currentUser.team_user_id;
            });
        }
    };

    var init = function () {
        initData();

        self.timesheetErrorReasons = [];

        self.loading = true;
        self.brand = brand;
        self.isTroncNamingConventionApplied = tipsDistributionSharedFactory.isTroncNamingConventionApplied(brand.team_live_country_code)
        self.isUSBrand = brand.team_live_country_code === "US";
        self.teamLiveCountryCode = brand.team_live_country_code;
        var appliedPermissionsForPayTypes = TeamScheduleService.getBrandPayTypePermissions(brand);
        var appliedViewPermissionsForPayTypes = TeamScheduleService.getBrandPayTypePermissions(brand, true);
        var nextWeekLockStatusDetails = CTTimesheetService.getTimesheetLockStatuses('NEXT_WEEK');
        nextWeekOfSelectedWeekStatus = nextWeekLockStatusDetails && nextWeekLockStatusDetails.isLocked ? 'LOCKED' : 'UNLOCKED';
        self.isGreaterThan24Hours = CTTimesheetService.checkIfClockGreaterThan24Hours(self.shift);
        weekPaysheetTypesInfo = CTTimesheetService.getEffectivePaysheetTypesInfo();
        var unpaidBreaksSettings = CTTimesheetService.breaksSettings['unpaid_breaks'] || {};
        self.missedUnpaidBreakMode = unpaidBreaksSettings.missed_unpaid_break_action_mode;
        self.missedUnpaidBreakAction = unpaidBreaksSettings.missed_unpaid_break_action;

        if (['UK', 'DK'].indexOf(self.teamLiveCountryCode) > -1) {
            if (brand['pay_types_overtime']) {
                var salariedOTVersions = brand['pay_types_overtime'].salaried_weekly_overtime;

                if (salariedOTVersions && salariedOTVersions.length) {
                    for (var i = 0; i < salariedOTVersions.length; i++) {
                        var salariedOT = salariedOTVersions[i];
                        if (
                            (moment(salariedOT.start_date).isSameOrBefore(self.selectedDate))) {
                            self.salariedWeeklyOT = salariedOT;
                            break;
                        }
                    }
                }

                var shiftyOTVersions = brand['pay_types_overtime'].weighted_shift_weekly_overtime;

                if (shiftyOTVersions && shiftyOTVersions.length) {
                    for (var i = 0; i < shiftyOTVersions.length; i++) {
                        var shiftyOT = shiftyOTVersions[i];
                        if (moment(shiftyOT.start_date).isSameOrBefore(moment(self.selectedDate))) {
                            self.shiftyWeeklyOT = shiftyOT;
                            break;
                        }
                    }
                }

                if (self.shiftyWeeklyOT && self.shiftyWeeklyOT.is_active || self.salariedWeeklyOT && self.salariedWeeklyOT.is_active) {
                    self.data.entitledOvertime = true;
                }
            }
        }

        self.data.meals = 0;
        self.data.meals_value = 0;

        var initialPromises = {};
        initialPromises["activeEmployee"] = getEmployerPrivilegedActiveEmployees(true);
        initialPromises["policyParser"] = userPermissions.getBrandPolicy(brand.id);
        initialPromises["isTipsDistributionEnabled"] = userServices.isServiceEnabled(userServices.SERVICES.TIPS_DISTRIBUTION, brand.id);
        initialPromises["employeeLatenessReasons"] = CTTimesheetService.getEmployeeLatenessReasons(brand.id);
        initialPromises["isMealPlanParticipantServiceEnabled"] = brandServices.check(brandServices.SERVICES.MEAL_PLAN_PARTICIPANT, brand.id);
        initialPromises["isJobTitleSkillLevelServiceEnabled"] = brandServices.check(brandServices.SERVICES.JOB_TITLE_SKILL_LEVEL, brand.id);
        initialPromises["employerTimesheetSettings"] = CTTimesheetService.getEmployerTimesheetSettings();

        $q.all(initialPromises)
            .then(function (res) {
                self.isPaySheetAdmin = res["policyParser"].has(userPermissions.PERMISSIONS.ADVANCED_PDS_ACCESS);
                self.isTipsDistributionServiceEnabled = res["isTipsDistributionEnabled"];
                self.employeeLatenessReasons = res['employeeLatenessReasons'];
                self.isMealPlanParticipantServiceEnabled = res['isMealPlanParticipantServiceEnabled'];
                isBreakWaiverSettingEnabled = CTTimesheetService.isBreakWaiverOnFileSettingEnabled();

                isJobTitleSkillLevelServiceEnabled = res['isJobTitleSkillLevelServiceEnabled'];
                brandJobTitleExtraPaySettings = res['employerTimesheetSettings']?.brand_job_title_extra_pay_settings;
                isAssigneeShiftJobTitleTimesEnforced = res['employerTimesheetSettings']?.is_assignee_shift_job_title_times_enforced;
                canManageOwnTimeCards = res["policyParser"].has(userPermissions.PERMISSIONS.MANAGE_OWN_TIME_CARDS);
                hasResolveBreakPremiumsPermission = res['policyParser'].has(userPermissions.PERMISSIONS.RESOLVE_CALIFORNIA_BREAK_PREMIUMS);
                updateEmployeesByManageOwnTimecardPermission();

                if (employee) {
                    userActivePaytype = TSUsersService.getUserActivePayType(employee.id, self.selectedDate);
                    updateBreaksTypesList();
                    var positionCode = employee && employee.positions && employee.positions[0] && employee.positions[0].code;
                    var positionCategory;

                    if (shift && shift.actual_clock) {
                        positionCategory = shift.actual_clock.position && shift.actual_clock.position.category.code;
                    }

                    self.troncTypeSupported = tipsDistributionSharedFactory.isClockTimeTroncSummaryVisible(
                        TIPS_DISTRIBUTION_SOURCE_VIEW.TIMESHEET,
                        brand.tronc,
                        [
                            userActivePaytype,
                        ],
                    );

                    if (userActivePaytype && positionCategory) {
                        var activeTypeManageWagePermission = 'MANAGE_' + userActivePaytype + '_EMPLOYEES_WAGES';
                        var activeTypeViewWagePermission = 'VIEW_' + userActivePaytype + '_EMPLOYEES_WAGES';
                        self.canManageWagesForThisPositionAndPayType = res["policyParser"].hasAny([activeTypeManageWagePermission, activeTypeViewWagePermission]);
                    } else {
                        self.canManageWagesForThisPositionAndPayType = false;
                    }
                }

                self.isDiffrentialPaymentWarningMsgShown = self.shift &&
                    self.shift.actual_clock &&
                    self.shift.actual_clock.differential_pay &&
                    self.shift.actual_clock.differential_pay.rules &&
                    self.shift.actual_clock.differential_pay.rules.length;

                for (var i in brand.employee_payment_types) {
                    var paymentType = brand.employee_payment_types[i];

                    if (paymentType.type === "WEIGHTED_SHIFT" || (paymentType.type === "SALARIED" && paymentType.track_mode === "WEIGHTED_SHIFT")) {
                        self.showShiftValue = true;
                        break;
                    }
                }

                checkClockTimeStatusReasonTrackingMode();


                if (self.splitShiftEnabled && self.mode === 'ADD') {
                    self.data.split_shift_status = true;
                }

                if (self.clockTimeStatusReasonTrackingMode === 'EXPLICIT' || self.callInEnabled) {
                    var reasonFound = _.find(clockTimeStatusReasons, {"key": clockTimeStatusPersonalReasonMode.key});
                    if (!reasonFound) {
                        clockTimeStatusReasons.push(clockTimeStatusPersonalReasonMode);
                    }
                    self.clockOutTimeStatusReasons = angular.copy(clockTimeStatusReasons);
                    self.clockInTimeStatusReasons = angular.copy(clockTimeStatusReasons);

                    if (self.isSickLeaveEnabled) {
                        self.clockOutTimeStatusReasons.push({
                            key: 'SICK_LEAVE',
                            value: 'Sick Leave'
                        });
                    }
                }

                var promises = {};
                promises['active_errors_lockup'] = TimesheetSettingsService.getTimesheetErrorsFlatList(false);
                promises['errors_lockup'] = TimesheetSettingsService.getTimesheetErrorsFlatList(true);

                if (self.shift && isBreakWaiverSettingEnabled) {
                    let requestDate = shift.isExtendedFromPreviousDay ? self.selectedDate.clone().subtract(1, 'days') : self.selectedDate;
                    promises['waiverOnFileStatus'] = PerformanceAggregatorAPI.getWaiverOnFileStatus(brand.id, employee.id, requestDate.format('YYYY-MM-DD'));
                }
                if (isJobTitleSkillLevelServiceEnabled) {
                    promises["brandJobTitles"] = BrandAPI.getBrandJobTitlesWithRestrictedPositions(brand.id);
                    promises['users_job_titles'] = TeamAPI.getAllUsersJobTitles(brand.id);
                    isJobTitleExtraPaySettingEnabled = checkJobTitleExtraPaySettingVersion(brandJobTitleExtraPaySettings)
                }

                $q.all(promises)
                    .then(function (result) {
                        self.timesheetErrorReasons = result['active_errors_lockup'];
                        var errorsLockup = result['errors_lockup'];

                        if (result['waiverOnFileStatus']) {
                            self.waiverOnFileBreakTypes = getAppliedWaiverOnFileTypes(result['waiverOnFileStatus']);
                        }

                        if (self.shift) {
                            self.mode = 'EDIT';

                            if (shift.status !== "DELETED" && shift.rate) {
                                self.hasFinancialWarning = CTTimesheetService.hasViewEmployeeWagePermissions(res["policyParser"], shift);
                            }

                            if (
                                self.showTips()
                            ) {
                                self.data["tips"] = parseFloat((parseFloat(self.shift && self.shift.tips && self.shift.tips.amount || 0) / 100).toFixed(2));

                                if (self.shift.isExtendedFromPreviousDay) {
                                    self.shift.is_tips_editable = false;
                                }
                            }

                            updateShiftTime(self.shift);
                            formatBreaksForView(self.shift.actual_clock.breaks);

                            if (self.data.clock_in && self.data.clock_out) {
                                self.shiftTimeIsValid = true;
                                if (self.shift.is_editable &&
                                    !self.shift.isViewOnly &&
                                    self.effectiveBreakEngine !== 'STATIC' &&
                                    self.hasBreakRules) {
                                    recalculateBreaks(null, true);
                                }
                            }

                            if (self.shift.category === 'ORDINARY' && (!self.shift.actual_clock.clock_out || !self.shift.actual_clock.clock_in)) {
                                self.shift.category = "NO";
                            }

                            if (self.shift.category !== 'ORDINARY' && self.shift.actual_clock.error_reason && self.shift.actual_clock.error_reason.id) {
                                if (errorsLockup.length) {
                                    var reason = _.find(errorsLockup, function (item) {
                                        return item.id === self.shift.actual_clock.error_reason.id;
                                    });

                                    if (reason) {
                                        self.data.category = reason;
                                    }
                                }
                            } else {
                                if (
                                    [
                                        'NO',
                                        'NO_SHOW',
                                        'SICK_LEAVE',
                                        'NO_SHOW_MANAGER_REQUEST',
                                        'LEAVE_OF_ABSENCE'
                                    ].indexOf(self.shift.category) > -1
                                ) {
                                    self.data.category = shift.category;
                                }
                            }

                            if (self.data.category && self.data.category.status === "ARCHIVED") {
                                self.timesheetErrorReasons.unshift(self.data.category)
                            }

                            if (self.data.category) {
                                self.data.category = _.find(self.timesheetErrorReasons, function (reason) {
                                    if (reason.id) {
                                        return reason.id === self.data.category.id;
                                    } else {
                                        return reason.category === self.data.category;
                                    }
                                });
                            }

                            if (self.shift.category != 'LEAVE_OF_ABSENCE') {
                                self.timesheetErrorReasons = self.timesheetErrorReasons.filter(function (reason) {
                                    return reason.category != 'LEAVE_OF_ABSENCE' && reason.type !== 'CALL_IN';
                                });
                            }

                            if (self.shift.scheduled_shift && self.shift.scheduled_shift.breaks) {
                                var scheduledBreaks = angular.copy(self.shift.scheduled_shift.breaks) || [];
                                self.shift.scheduled_shift.breaks = [];
                                self.shift.scheduled_shift.breaks = _.filter(scheduledBreaks, function (breakItem) {
                                    return breakItem.type === 'PAID' || breakItem.type === 'UNPAID';
                                });
                            }

                            if (self.splitShiftEnabled) {
                                self.data.split_shift_status = self.shift.actual_clock.split_shift_penalty && self.shift.actual_clock.split_shift_penalty.status === "INCLUDED";
                            }

                            if (self.shiftBasedScheduling) {
                                self.data.weight = updateShiftValue(self.shift.actual_clock.weight);

                                if (self.shift.actual_clock.code) {
                                    self.shiftCode = {code: self.shift.actual_clock.code, name: self.shift.actual_clock.code};
                                } else {
                                    self.shiftCode = TEMPLATE_NONE_OPTION;
                                }
                            }

                            if (
                                self.clockTimeStatusReasonTrackingMode === 'EXPLICIT' ||
                                self.isSickLeaveEnabled ||
                                self.callInEnabled
                            ) {
                                if (self.shift.actual_clock.clock_in_action && Object.keys(self.shift.actual_clock.clock_in_action).length) {
                                    self.showNoneClockInReason = self.shift.actual_clock.clock_in_action.reason === "NONE";
                                    self.data.clock_in_action_reason = getReasonCode(self.shift.actual_clock.clock_in_action.reason);
                                    self.data.clock_in_action_warning = getClockActionWarning(self.shift.actual_clock.clock_in_action);
                                } else {
                                    self.showNoneClockInReason = true;
                                    self.data.clock_in_action_reason = "NONE";
                                }

                                if (self.shift.actual_clock.clock_out_action && Object.keys(self.shift.actual_clock.clock_out_action).length) {
                                    self.showNoneClockOutReason = self.shift.actual_clock.clock_out_action.reason === "NONE";
                                    self.data.clock_out_action_reason = getReasonCode(self.shift.actual_clock.clock_out_action.reason);
                                    self.data.clock_out_action_warning = getClockActionWarning(self.shift.actual_clock.clock_out_action);
                                } else {
                                    self.showNoneClockOutReason = true;
                                    self.data.clock_out_action_reason = "NONE";
                                }
                            }

                            if (
                                shift.employee_status
                            ) {
                                switch (shift.employee_status) {
                                    case CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYEE_PROTESTED:
                                        self.isRequestEmployeeConfirmationDisabled = true;
                                        self.isOverrideEmployeeConfirmationDisbaled = false;
                                        self.data.employee_confirmation_type = 'OVERRIDE_EMPLOYEE_CONFIRMATION';
                                        break;

                                    case CTTimesheetService.EMPLOYEE_STATUSES_ACK.PENDING_EMPLOYEE_APPROVAL:
                                    case CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYEE_APPROVED:
                                    case CTTimesheetService.EMPLOYEE_STATUSES_ACK.EMPLOYER_APPROVED:
                                    default:
                                        self.isOverrideEmployeeConfirmationDisbaled = true;
                                        self.isRequestEmployeeConfirmationDisabled = false;
                                        self.data.employee_confirmation_type = 'REQUEST_EMPLOYEE_CONFIRMATION';

                                        break;
                                }
                            } else {
                                self.isOverrideEmployeeConfirmationDisbaled = true;
                                self.isRequestEmployeeConfirmationDisabled = false;
                                self.data.employee_confirmation_type = 'REQUEST_EMPLOYEE_CONFIRMATION';
                            }

                            checkOverlappingWithOtherClocks(true);
                        }

                        if (result['brandJobTitles'] && result['users_job_titles']) {
                            _jobTitleFuncs.setBusinessDayLimits(self.businessDayLimits);
                            _jobTitleFuncs.setShiftSelectedDate(self.selectedDate);
                            jobTitlesDataService.setUsersJobTiles(result.users_job_titles);
                            jobTitlesDataService.setBrandJobTitles(result.brandJobTitles.job_titles || []);
                            _jobTitleFuncs.updateIntervalStartAndEndTime({
                                start_time: self.data.moment_clock_in,
                                end_time: self.data.moment_clock_out
                            });
                            _jobTitleFuncs.prepareBrandUserJobTitlesListOptions(self.data?.employee?.id);
                            const jobTitles = self.shift?.actual_clock?.stations_extra_pay?.job_titles;
                            let parsedJobTitles = [];
                            if (jobTitles?.length) {
                                originalJobTitlesData = JSON.parse(JSON.stringify(jobTitles));
                                parsedJobTitles = jobTitles.map(jt => ({
                                    ...jt,
                                    start_time: $filter("formatDateIgnoreTimeZone")(jt.start_time),
                                    end_time: $filter("formatDateIgnoreTimeZone")(jt.end_time),
                                    job_title_id: jt.job_title_lookup_id,
                                    show_timesheet_rate: true
                                }))
                            }
                            const mappedJobTitles = _jobTitleFuncs.mapJobTitles(parsedJobTitles);
                            originalData = {
                                moment_clock_in: self.data.moment_clock_in?.clone(),
                                moment_clock_out: self.data.moment_clock_out?.clone()
                            };
                            _jobTitleFuncs.setIsAssigneeShiftJobTitleTimesEnforced(isAssigneeShiftJobTitleTimesEnforced && !self.isPartiallyPaidShift(null, 'CLOCK_IN'));
                            self.initJobTitles(mappedJobTitles);
                        }

                        originalData = $.extend(true, {}, self.data);
                        showChangeTimeCardActionsAndWarnings(true);
                        originalClock = {
                            actual_clock: {
                                clock_in: self.data['moment_clock_in'],
                                clock_out: self.data['moment_clock_out']
                            }
                        };
                        $scope.$digest();
                    });

                updateCurrency();
                if (self.isDiffrentialPaymentWarningMsgShown) {
                    self.diffrentialPaymentRules = getDifferentialPaymentRulesMessages(self.shift.actual_clock.differential_pay.rules);
                }

                self.incentiveExtraPayRulesMessages = getAppliedIncentiveExtraPayRulesMessages(self.shift);

            }, function (err) {
                console.error(err)
            });
    };

    const getAppliedWaiverOnFileTypes = (waiverOnFileBreakTypes) => {
        return waiverOnFileBreakTypes.reduce((acc, file) => {
            const consentedBreaks = file.breaks.filter(breakInfo => breakInfo.status === "CONSENTED");
            return acc.concat(consentedBreaks);
        }, []);
    };


    self.canViewStationsSection = () => {
        const isSectionShown = (
            isJobTitleSkillLevelServiceEnabled &&
            userActivePaytype === "HOURLY" &&
            isJobTitleExtraPaySettingEnabled
        )
        if (!isSectionShown) {
            self.data.job_titles = [];
        }
        return isSectionShown;
    }

    const checkJobTitleExtraPaySettingVersion = (settingVersions) => {
        const settingVersion = settingVersions?.find(setting => self.selectedDate.isSameOrAfter(moment(setting?.start_date), 'day'));
        return settingVersion?.enable_station_extra_pay;
    }

    self.isShiftFieldsDisabled = (jobTitle, inputToBeDisabled) => {
        return (
            self.isPartiallyPaidShift(jobTitle, inputToBeDisabled) ||
            !self.isFormEditable() ||
            !(
                self.data.employee &&
                self.data.clock_in &&
                self.data.clock_out
            )
        )
    }

    var updateShiftTime = function (shift) {
        if (shift.actual_clock.clock_in) {
            self.data.clock_in = $filter("formatDateIgnoreTimeZone")(shift.actual_clock.clock_in, "hh:mm A");
            self.data['moment_clock_in'] = moment(shift.actual_clock.clock_in, 'YYYY-MM-DDTHH:mm:ss');
        }

        if (shift.actual_clock.clock_out) {
            self.data.clock_out = $filter("formatDateIgnoreTimeZone")(shift.actual_clock.clock_out, "hh:mm A");
            self.data['moment_clock_out'] = moment(shift.actual_clock.clock_out, 'YYYY-MM-DDTHH:mm:ss');
        }


        if (self.showExtendedShiftIcon()) {
            self.clock_out_meta = {
                appendText: $filter('translate')('Next Day'),
                prependIcon: 'next-day-icon'
            }
        } else {
            self.clock_out_meta = {
                appendText: '',
                prependIcon: ''
            }
        }

        prepareShiftClockOutTimeOptions();
        prepareTimeOptions();
    }

    self.showUSLabels = function () {
        return ['US', 'PH'].indexOf( self.teamLiveCountryCode) > -1;
    };
    self.showUKLabels = function () {
        return ['UK', 'DK'].indexOf( self.teamLiveCountryCode) > -1;
    };

    self.onOptionSelect = function (target, interval) {
        return function (option) {
            var metaObj = {};
            if (option.next_day) {
                metaObj.appendText = $filter('translate')('Next Day');
                metaObj.prependIcon = 'next-day-icon';
            }
            else {
                metaObj.appendText = '';
                metaObj.prependIcon = '';
            }

            if (interval) {
                interval[target + '_meta'] = metaObj;
            } else {
                self[target + '_meta'] = metaObj;
            }
        }
    };

    init();
};

